import React, {Component} from 'react';
import moment from 'moment';
import 'moment/locale/tr';
import {Col, Row} from 'reactstrap';
import {checkDuplicateTcknVkns, deepCopyObject, fetchAllPkList, showAxiosError} from "../../../helper/helper";
import {request} from "../../../helper/APIUtils";
import DefaultModal from "../../invoice/DefaultModal";
import {Decimal} from 'decimal.js';
import Alert from "react-s-alert";
import XLSX from 'xlsx';
import CreateEditVoucher from "../CreateEditVoucher";
import VoucherLines from "./VoucherLines";
import DespatchLines from "../../despatch/component/DespatchLines";
import {
    defaultBelge,
    defaultDespatch,
    defaultExternalCustomer,
    defaultInvoice, defaultSigorta,
    defaultStock,
    defaultSVoucher,
    defaultVoucher
} from "../helper/defaultData";
import InvoiceLines from "../../invoice/component/InvoiceLines";
import CreateEditInvoice from "../../invoice/CreateEditInvoice";
import TextOverFlowTooltip from "../../../components/TextOverFlowTooltip";
import axios from 'axios';
import GetEnumDataAndValidation from "./GetEnumDataAndValidation";
import BelgeLines from "../../ebelge/tmp/BelgeLines";
import CreateEditBelge from "../../ebelge/tmp/CreateEditBelge";

class ReadFromExcel extends Component {

    constructor(props) {
        super(props);
        this.state = {error: {}, documentList: [], index: 0, stoppageTypes: [], controlObjectList:[],exemptions:[],isMobile:window.innerWidth > 991 ? false : true};
        this.onCancel = this.onCancel.bind(this);
        this.sendDocument = this.sendDocument.bind(this);
        this.saveNextDocument = this.saveNextDocument.bind(this);
        this.removeDocument = this.removeDocument.bind(this);
        this.fileSelected = this.fileSelected.bind(this);
        this.triggerFileSelect = this.triggerFileSelect.bind(this);
        this.bulkFileSelected = this.bulkFileSelected.bind(this);
        this.exportToExcel = this.exportToExcel.bind(this);
        this.exportExternalCustomerToExcel = this.exportExternalCustomerToExcel.bind(this);
        this.exportStockToExcel = this.exportStockToExcel.bind(this);
        this.exportStockToExcelCurreny = this.exportStockToExcelCurreny.bind(this);
        this.exportStockToExcelUnits = this.exportStockToExcelUnits.bind(this);
        this.exportExemptionsToExcel = this.exportExemptionsToExcel.bind(this);
        this.exportVoucherToExcel = this.exportVoucherToExcel.bind(this);
        this.exportInvoiceToExcel = this.exportInvoiceToExcel.bind(this);
        this.voucherToDocumentList = this.voucherToDocumentList.bind(this);
        this.sVoucherToDocumentList = this.sVoucherToDocumentList.bind(this);
        this.despatchToDocumentList = this.despatchToDocumentList.bind(this);
        this.stockToDocumentList = this.stockToDocumentList.bind(this);
        this.externalCustomerToDocumentList = this.externalCustomerToDocumentList.bind(this);
        this.orientation = this.orientation.bind(this);
        this.sendDespatch = this.sendDespatch.bind(this);
        this.saveStockList = this.saveStockList.bind(this);
        this.saveExternalCustomerList = this.saveExternalCustomerList.bind(this);
        this.exportStockToExcelStoppageTypes = this.exportStockToExcelStoppageTypes.bind(this);
        this.getStoppageTypes = this.getStoppageTypes.bind(this);
        this.getExemptions = this.getExemptions.bind(this);
        this.exportWithholdingTypes = this.exportWithholdingTypes.bind(this);
        this.exportWithholdingTypesToExcel = this.exportWithholdingTypesToExcel.bind(this);
        this.sigortaToDocumentList = this.sigortaToDocumentList.bind(this);
        this.exportSigortaToExcel = this.exportSigortaToExcel.bind(this);
        this.saveSigorta = this.saveSigorta.bind(this);
        this.inputFile = React.createRef();
    }

    componentDidMount() {
        this.getExemptions();
    }


    fileSelected(event) {
        let self = this;
        let files = event.dataTransfer ? event.dataTransfer.files : event.target.files;

        if (!!files) {
            if (files[0].name.endsWith(".xls") || files[0].name.endsWith(".xlsx") || files[0].name.endsWith(".XLS") || files[0].name.endsWith(".XLSX")) {
                let fileReader = new FileReader();
                fileReader.readAsArrayBuffer(files[0]);
                self.setState({processingExcel: true, uploadBtnDisabled: true, excelDatas: [], documentList: []});
                fileReader.onload = () => {
                    self.bulkFileSelected(fileReader.result);
                };

                event.target.value = null;
            } else {
                Alert.closeAll();
                Alert.error('Dosya uzantısı yalnızca \'xlsx\' ya da \'xls\' olmalıdır.', {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            }
        }
    }

    pad(s, size) {
        let str = "" + s;
        while (str.length < (size || 2)) {
            str = "0" + str;
        }
        return str;
    }

    bulkFileSelected(fileContent) {
        let self = this;
        let type = self.props.type;
        if (type === "voucher") {
            self.voucherToDocumentList(fileContent);
        } else if (type === "sVoucher") {
            self.sVoucherToDocumentList(fileContent);
        } else if (type === "invoice") {
            self.invoiceToDocumentList(fileContent);
        } else if (type === "belge") {
            self.belgeToDocumentList(fileContent);
        } else if (type === "despatch") {
            self.despatchToDocumentList(fileContent);
        } else if (type === "stockList") {
            self.stockToDocumentList(fileContent);
        } else if(type === "sigorta"){
            self.sigortaToDocumentList(fileContent);
        }else if (type === "externalCustomerList") {
            self.sendExceltoBackend(fileContent);
            //self.externalCustomerToDocumentList(fileContent)
        }
    }

    async invoiceToDocumentList(fileContent) {
        let self = this;
        let workbook = XLSX.read(fileContent, {type: "array"});
        let sheet = workbook.Sheets[workbook.SheetNames[0]];
        let documentTmpList = {};
        let error = "";
        let invoiceEnum = [];
        let documentList = [];
        let excelDatas = [];
        let notes = [];
        if (sheet["!ref"] != null) {
            let range = XLSX.utils.decode_range(sheet["!ref"]);
            let sheetcopy = sheet;
            let rowLength = XLSX.utils.decode_range(sheet["!ref"]);
            invoiceEnum = GetEnumDataAndValidation.getInvoiceEnum(sheetcopy, rowLength);
            let headerControl = GetEnumDataAndValidation.getHeaderInvoiceValidation(invoiceEnum);

            let withholdingCodes = await this.exportWithholdingTypes();

            for (let row = range.s.r; row <= range.e.r; row++) {
                if (row > -1) {
                    let rowData = {};
                    if (((range.e.c + 1) >= rowLength.e.c) && headerControl) {
                        for (let col = range.s.c; col <= range.e.c; col++) {
                            let cell = sheet[XLSX.utils.encode_cell({r: row, c: col})];
                            if (invoiceEnum[col] === undefined) {
                                break;
                            }

                            if (cell === undefined) {
                                rowData[invoiceEnum[col][col]] = null;
                                continue;
                            }

                            if (invoiceEnum[col][col] === "documentNo") {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            } else if (invoiceEnum[col][col] === "profileId" && (typeof cell.v === 'string')) {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            } else if (invoiceEnum[col][col] === "invoiceTypeCode" && (typeof cell.v === 'string')) {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            } else if (invoiceEnum[col][col] === "issueDate") {
                                if (!cell.v) {
                                    let dateTime = XLSX.SSF.parse_date_code(cell.v);

                                    rowData[invoiceEnum[col][col]] = this.pad(dateTime.y) + "-" + this.pad(dateTime.m) + "-" + dateTime.d + "T" + this.pad(dateTime.H) + ":" + this.pad(dateTime.M) + ":" + this.pad(dateTime.S);
                                } else {
                                    rowData[invoiceEnum[col][col]] = (cell.w ? (cell.w).replace(new RegExp("/", 'g'), "-") : cell.w);
                                }
                            } else if (invoiceEnum[col][col] === "issueTime") {
                                rowData[invoiceEnum[col][col]] = cell.w;
                            } else if (invoiceEnum[col][col] === "destinationUrn") {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            } else if (invoiceEnum[col][col] === "sourceUrn") {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            } else if (invoiceEnum[col][col] === "email" && (typeof cell.v === 'string')) {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            } else if (invoiceEnum[col][col] === "telephone"){
                                rowData[invoiceEnum[col][col]] = cell.v;
                            } else if (invoiceEnum[col][col] === "documentCurrencyCode" && (typeof cell.v === 'string')) {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            } else if (invoiceEnum[col][col] === "paymentExchangeRate") {
                                rowData[invoiceEnum[col][col]] = (typeof cell.v === 'number') ? new Decimal(new Decimal(cell.v).toFixed(2)).toNumber() : null;
                            } else if (invoiceEnum[col][col] === "vknTckn") {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            } else if (invoiceEnum[col][col] === "formattedName") {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            } else if (invoiceEnum[col][col] === "givenName") {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            } else if (invoiceEnum[col][col] === "familyName") {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            } else if (invoiceEnum[col][col] === "citySubdivisionName" && (typeof cell.v === 'string')) {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            } else if (invoiceEnum[col][col] === "cityName" && (typeof cell.v === 'string')) {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            } else if (invoiceEnum[col][col] === "countryName" && (typeof cell.v === 'string')) {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            } else if (invoiceEnum[col][col] === "streetName") {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            } else if (invoiceEnum[col][col] === "taxOffice") {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            } else if (invoiceEnum[col][col] === "invoiceNumber") {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            } else if (invoiceEnum[col][col] === "iadeIssueDate") {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            }  else if (invoiceEnum[col][col] === "iadeIssueTime") {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            } else if (invoiceEnum[col][col] === "itemName" && (typeof cell.v === 'string')) {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            } else if (invoiceEnum[col][col] === "quantity" && (typeof cell.v === 'number')) {
                                rowData[invoiceEnum[col][col]] = new Decimal(cell.v).toNumber();
                            } else if (invoiceEnum[col][col] === "unitPrice" && (typeof cell.v === 'number')) {
                                rowData[invoiceEnum[col][col]] = new Decimal(cell.v).toNumber();
                            } else if (invoiceEnum[col][col] === "unit" && (typeof cell.v === 'string')) {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            } else if (invoiceEnum[col][col] === "iskontoPercentage" && (typeof cell.v === 'number')) {
                                rowData[invoiceEnum[col][col]] = new Decimal(new Decimal(cell.v).toFixed(2)).toNumber();
                            } else if (invoiceEnum[col][col] === "kdvPercentage" && (typeof cell.v === 'number')) {
                                rowData[invoiceEnum[col][col]] = new Decimal(new Decimal(cell.v).toFixed(2)).toNumber();
                            } else if (invoiceEnum[col][col] === "exemptionReasonCode") {
                                rowData[invoiceEnum[col][col]] = cell.v.toString();
                            }else if (invoiceEnum[col][col] === "note") {
                                rowData[invoiceEnum[col][col]] = cell.v.toString();
                            }else if (invoiceEnum[col][col] === "referenceId") {
                                rowData[invoiceEnum[col][col]] = cell.v.toString();
                            }else if (invoiceEnum[col][col] === "gtip") {
                                rowData[invoiceEnum[col][col]] = cell.v.toString();
                            }else if (invoiceEnum[col][col] === "referenceIssueDate") {
                                if (!cell.v) {
                                    let dateTime = XLSX.SSF.parse_date_code(cell.v);
                                    rowData[invoiceEnum[col][col]] = this.pad(dateTime.y) + "-" + this.pad(dateTime.m) + "-" + dateTime.d;
                                } else {
                                    rowData[invoiceEnum[col][col]] = (cell.w ? (cell.w).replace(new RegExp("/", 'g'), "-") : cell.w);
                                }
                            }else if (invoiceEnum[col][col] === "tevkifatAmount") {
                                rowData[invoiceEnum[col][col]] = new Decimal(new Decimal(parseFloat(cell.v)).toFixed(2)).toNumber();
                            }else if (invoiceEnum[col][col] === "internetSaleArea") {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            }else if (invoiceEnum[col][col] === "webSite") {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            }else if (invoiceEnum[col][col] === "paymentMethod") {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            }else if (invoiceEnum[col][col] === "paymentDetails") {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            }else if (invoiceEnum[col][col] === "paymentDate") {
                                if (!cell.v) {
                                    let dateTime = XLSX.SSF.parse_date_code(cell.v);
                                    rowData[invoiceEnum[col][col]] = this.pad(dateTime.y) + "-" + this.pad(dateTime.m) + "-" + dateTime.d;
                                } else {
                                    rowData[invoiceEnum[col][col]] = (cell.w ? (cell.w).replace(new RegExp("/", 'g'), "-") : cell.w);
                                }
                            }else if (invoiceEnum[col][col] === "carrierFirstName") {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            }else if (invoiceEnum[col][col] === "carrierFamilyName") {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            }else if (invoiceEnum[col][col] === "carrierTitle") {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            }else if (invoiceEnum[col][col] === "carrierVknTckn") {
                                rowData[invoiceEnum[col][col]] = cell.v;
                            }else if (invoiceEnum[col][col] === "deliveryDate") {
                                if (!cell.v) {
                                    let dateTime = XLSX.SSF.parse_date_code(cell.v);
                                    rowData[invoiceEnum[col][col]] = this.pad(dateTime.y) + "-" + this.pad(dateTime.m) + "-" + dateTime.d;
                                } else {
                                    rowData[invoiceEnum[col][col]] = (cell.w ? (cell.w).replace(new RegExp("/", 'g'), "-") : cell.w);
                                }
                            }
                        }
                        let controlObject = 1;

                        rowData = GetEnumDataAndValidation.setName(rowData, controlObject, row);

                        let invoiceValidation = GetEnumDataAndValidation.invoiceValidation(rowData, row, controlObject, this.props.profileId,this.state.exemptions,withholdingCodes);
                        controlObject = invoiceValidation.controlObject;
                        error = error + invoiceValidation.error;

                        if (rowData && Object.keys(rowData).length <= rowLength.e.c+1 && row != 0 && controlObject) {
                            if (rowData["documentNo"] in documentTmpList) {
                                documentTmpList[rowData["documentNo"]].push(rowData);
                            } else {
                                documentTmpList[rowData["documentNo"]] = [rowData]
                            }
                        }
                    }
                }
            }
            if (!headerControl) {
                error = error + " <strong> Doküman içerisinde zorunlu başlık alanları hatalı. Dokümanı kontrol ediniz.</strong><br/>";
            }

            for (let key in documentTmpList) {

                documentList.push(defaultInvoice(documentTmpList[key],this.state.exemptions,withholdingCodes));
                let documentTmp = documentTmpList[key];
                excelDatas.push({
                    issueDate: documentTmp[0]["issueDate"],
                    issueTime: documentTmp[0]["issueTime"],
                    fullName: documentTmp[0]["formattedName"] || documentTmp[0]["givenName"] + " " + documentTmp[0]["familyName"],
                    vknTckn: documentTmp[0]["vknTckn"],
                    profileId: documentTmp[0]["profileId"]
                });
            }

            for (let i = 0; i < documentList.length; i++) {
                let invoice = documentList[i];
                for (let j = 0; j < invoice.trdDocInvoiceLines.length; j++) {
                    invoice.trdDocInvoiceLines[j] = InvoiceLines.calculate(invoice.trdDocInvoiceLines[j]);
                }
                documentList[i] = CreateEditInvoice.calculateTotal(documentList[i]);
                excelDatas[i]["payableAmount"] = documentList[i]["payableAmount"];
            }
        } else {
            error = error + " <strong> Boş bir doküman yüklediniz.</strong><br/>";
        }

        self.setState({
            documentList: documentList,
            processingExcel: false,
            excelDatas: excelDatas,
            uploadBtnDisabled: false,
            index: 0
        });
        if (error) {
            Alert.closeAll();
            Alert.info(error, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 8000
            });
        }
    }


    async belgeToDocumentList(fileContent) {
        let self = this;
        let workbook = XLSX.read(fileContent, {type: "array"});
        let sheet = workbook.Sheets[workbook.SheetNames[0]];
        let documentTmpList = {};
        let error = "";
        let belgeEnum = [];
        let documentList = [];
        let excelDatas = [];
        let notes = [];
        if (sheet["!ref"] != null) {
            let range = XLSX.utils.decode_range(sheet["!ref"]);
            let sheetcopy = sheet;
            let rowLength = XLSX.utils.decode_range(sheet["!ref"]);
            belgeEnum = GetEnumDataAndValidation.getBelgeEnum(sheetcopy, rowLength);
            let headerControl = GetEnumDataAndValidation.getHeaderBelgeValidation(belgeEnum);

            let withholdingCodes = await this.exportWithholdingTypes();

            for (let row = range.s.r; row <= range.e.r; row++) {
                if (row > -1) {
                    let rowData = {};
                    if (((range.e.c + 1) >= 27) && headerControl) {
                        for (let col = range.s.c; col <= range.e.c; col++) {
                            let cell = sheet[XLSX.utils.encode_cell({r: row, c: col})];
                            if (belgeEnum[col] === undefined) {
                                break;
                            }

                            if (cell === undefined) {
                                rowData[belgeEnum[col][col]] = null;
                                continue;
                            }

                            if (belgeEnum[col][col] === "documentNo") {
                                rowData[belgeEnum[col][col]] = cell.v;
                            } else if (belgeEnum[col][col] === "documentTypeCode" && (typeof cell.v === 'string')) {
                                rowData[belgeEnum[col][col]] = cell.v;
                            } else if (belgeEnum[col][col] === "issueDate") {
                                if (!cell.v) {
                                    let dateTime = XLSX.SSF.parse_date_code(cell.v);

                                    rowData[belgeEnum[col][col]] = this.pad(dateTime.y) + "-" + this.pad(dateTime.m) + "-" + dateTime.d + "T" + this.pad(dateTime.H) + ":" + this.pad(dateTime.M) + ":" + this.pad(dateTime.S);
                                } else {
                                    rowData[belgeEnum[col][col]] = (cell.w ? (cell.w).replace(new RegExp("/", 'g'), "-") : cell.w);
                                }
                            } else if (belgeEnum[col][col] === "issueTime") {
                                rowData[belgeEnum[col][col]] = cell.w;
                            } else if (belgeEnum[col][col] === "email" && (typeof cell.v === 'string')) {
                                rowData[belgeEnum[col][col]] = cell.v;
                            } else if (belgeEnum[col][col] === "documentCurrencyCode" && (typeof cell.v === 'string')) {
                                rowData[belgeEnum[col][col]] = cell.v;
                            } else if (belgeEnum[col][col] === "paymentExchangeRate") {
                                rowData[belgeEnum[col][col]] = (typeof cell.v === 'number') ? new Decimal(new Decimal(cell.v).toFixed(2)).toNumber() : null;
                            } else if (belgeEnum[col][col] === "vknTckn") {
                                rowData[belgeEnum[col][col]] = cell.v;
                            } else if (belgeEnum[col][col] === "formattedName") {
                                rowData[belgeEnum[col][col]] = cell.v;
                            } else if (belgeEnum[col][col] === "givenName") {
                                rowData[belgeEnum[col][col]] = cell.v;
                            } else if (belgeEnum[col][col] === "familyName") {
                                rowData[belgeEnum[col][col]] = cell.v;
                            } else if (belgeEnum[col][col] === "citySubdivisionName" && (typeof cell.v === 'string')) {
                                rowData[belgeEnum[col][col]] = cell.v;
                            } else if (belgeEnum[col][col] === "cityName" && (typeof cell.v === 'string')) {
                                rowData[belgeEnum[col][col]] = cell.v;
                            } else if (belgeEnum[col][col] === "countryName" && (typeof cell.v === 'string')) {
                                rowData[belgeEnum[col][col]] = cell.v;
                            } else if (belgeEnum[col][col] === "streetName") {
                                rowData[belgeEnum[col][col]] = cell.v;
                            } else if (belgeEnum[col][col] === "taxOffice") {
                                rowData[belgeEnum[col][col]] = cell.v;
                            } else if (belgeEnum[col][col] === "itemName" && (typeof cell.v === 'string')) {
                                rowData[belgeEnum[col][col]] = cell.v;
                            } else if (belgeEnum[col][col] === "quantity" && (typeof cell.v === 'number')) {
                                rowData[belgeEnum[col][col]] = new Decimal(cell.v).toNumber();
                            } else if (belgeEnum[col][col] === "unitPrice" && (typeof cell.v === 'number')) {
                                rowData[belgeEnum[col][col]] = new Decimal(cell.v).toNumber();
                            } else if (belgeEnum[col][col] === "unit" && (typeof cell.v === 'string')) {
                                rowData[belgeEnum[col][col]] = cell.v;
                            } else if (belgeEnum[col][col] === "iskontoPercentage" && (typeof cell.v === 'number')) {
                                rowData[belgeEnum[col][col]] = new Decimal(new Decimal(cell.v).toFixed(2)).toNumber();
                            } else if (belgeEnum[col][col] === "kdvPercentage" && (typeof cell.v === 'number')) {
                                rowData[belgeEnum[col][col]] = new Decimal(new Decimal(cell.v).toFixed(2)).toNumber();
                            } else if (belgeEnum[col][col] === "exemptionReasonCode") {
                                rowData[belgeEnum[col][col]] = cell.v.toString();
                            }else if (belgeEnum[col][col] === "note") {
                                rowData[belgeEnum[col][col]] = cell.v.toString();
                            }else if (belgeEnum[col][col] === "referenceId") {
                                rowData[belgeEnum[col][col]] = cell.v.toString();
                            }else if (belgeEnum[col][col] === "referenceIssueDate") {
                                if (!cell.v) {
                                    let dateTime = XLSX.SSF.parse_date_code(cell.v);
                                    rowData[belgeEnum[col][col]] = this.pad(dateTime.y) + "-" + this.pad(dateTime.m) + "-" + dateTime.d;
                                } else {
                                    rowData[belgeEnum[col][col]] = (cell.w ? (cell.w).replace(new RegExp("/", 'g'), "-") : cell.w);
                                }
                            }else if (belgeEnum[col][col] === "tevkifatAmount") {
                                rowData[belgeEnum[col][col]] = new Decimal(new Decimal(parseFloat(cell.v)).toFixed(2)).toNumber();
                            }
                        }
                        let controlObject = 1;

                        rowData = GetEnumDataAndValidation.setName(rowData, controlObject, row);

                        let invoiceValidation = GetEnumDataAndValidation.belgeValidation(rowData, row, controlObject, this.props.profileId,this.state.exemptions,withholdingCodes);
                        controlObject = invoiceValidation.controlObject;
                        error = error + invoiceValidation.error;

                        if (rowData && Object.keys(rowData).length <= 27 && row != 0 && controlObject) {
                            if (rowData["documentNo"] in documentTmpList) {
                                documentTmpList[rowData["documentNo"]].push(rowData);
                            } else {
                                documentTmpList[rowData["documentNo"]] = [rowData]
                            }
                        }
                    }
                }
            }
            if (!headerControl) {
                error = error + " <strong> Doküman içerisinde zorunlu başlık alanları hatalı. Dokümanı kontrol ediniz.</strong><br/>";
            }

            for (let key in documentTmpList) {

                documentList.push(defaultBelge(documentTmpList[key],this.state.exemptions,withholdingCodes));
                let documentTmp = documentTmpList[key];
                excelDatas.push({
                    issueDate: documentTmp[0]["issueDate"],
                    issueTime: documentTmp[0]["issueTime"],
                    fullName: documentTmp[0]["formattedName"] || documentTmp[0]["givenName"] + " " + documentTmp[0]["familyName"],
                    vknTckn: documentTmp[0]["vknTckn"],
                    profileId: "EBELGE"
                });
            }

            for (let i = 0; i < documentList.length; i++) {
                let belge = documentList[i];
                for (let j = 0; j < belge.trdDocBelgeLines.length; j++) {
                    belge.trdDocBelgeLines[j] = BelgeLines.calculate(belge.trdDocBelgeLines[j]);
                }
                documentList[i] = CreateEditBelge.calculateTotal(documentList[i]);
                excelDatas[i]["payableAmount"] = documentList[i]["payableAmount"];
            }
        } else {
            error = error + " <strong> Boş bir doküman yüklediniz.</strong><br/>";
        }

        self.setState({
            documentList: documentList,
            processingExcel: false,
            excelDatas: excelDatas,
            uploadBtnDisabled: false,
            index: 0
        });
        if (error) {
            Alert.closeAll();
            Alert.info(error, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 8000
            });
        }
    }

    async voucherToDocumentList(fileContent) {
        let self = this;
        let workbook = XLSX.read(fileContent, {type: "array"});
        let sheet = workbook.Sheets[workbook.SheetNames[0]];
        let error = "";
        let VoucherEnum = [];
        let documentList = [];
        let documentFailed = ["Check"];
        let documentShow = [];
        let excelDatas = [];
        let documentListCrack = {};
        let documentShowCrack = [];
        let rowDataList = [];
        let index = 0;
        let stoppageTypes= await this.getStoppageTypes();
        if (sheet["!ref"] != null) {
            let range = XLSX.utils.decode_range(sheet["!ref"]);
            let sheetcopy = sheet;
            let rowLength = XLSX.utils.decode_range(sheet["!ref"]);
            VoucherEnum = GetEnumDataAndValidation.getVoucherEnum(sheetcopy, rowLength);
            let headerControl = GetEnumDataAndValidation.getHeaderVoucherValidation(VoucherEnum);
            for (let row = range.s.r; row <= range.e.r; row++) {
                if (row > -1) {
                    let rowData = {};
                    if (((range.e.c + 1) >= 14) && headerControl) {
                        for (let col = range.s.c; col <= range.e.c; col++) {
                            let cell = sheet[XLSX.utils.encode_cell({r: row, c: col})];
                            if (cell !== undefined) {
                                if (VoucherEnum[col][col] === "issueDate") {
                                    if (!cell.v) {
                                        let dateTime = XLSX.SSF.parse_date_code(cell.v);

                                        rowData[VoucherEnum[col][col]] = this.pad(dateTime.y) + "-" + this.pad(dateTime.m) + "-" + dateTime.d + "T" + this.pad(dateTime.H) + ":" + this.pad(dateTime.M) + ":" + this.pad(dateTime.S);
                                    } else {
                                        rowData[VoucherEnum[col][col]] = (cell.w ? (cell.w).replace(new RegExp("/", 'g'), "-") : cell.w);
                                    }
                                } else if (VoucherEnum[col][col] === "fullName" && (typeof cell.v === 'string')) {
                                    rowData[VoucherEnum[col][col]] = cell.v;
                                } else if (VoucherEnum[col][col] === "vknTckn") {
                                    rowData[VoucherEnum[col][col]] = cell.v;
                                }
                                else if (VoucherEnum[col][col] === "stockCode") {
                                    rowData[VoucherEnum[col][col]] = cell.v;
                                }
                                else if (VoucherEnum[col][col] === "documentNo") {
                                    rowData[VoucherEnum[col][col]] = cell.v;
                                } else if (VoucherEnum[col][col] === "fullAddress" && (typeof cell.v === 'string')) {
                                    rowData[VoucherEnum[col][col]] = cell.v;
                                } else if (VoucherEnum[col][col] === "itemName" && (typeof cell.v === 'string')) {
                                    rowData[VoucherEnum[col][col]] = cell.v;
                                } else if (VoucherEnum[col][col] === "quantity" && (typeof cell.v === 'number')) {
                                    rowData[VoucherEnum[col][col]] = cell.v;
                                } else if (VoucherEnum[col][col] === "unitPrice" && (typeof cell.v === 'number')) {
                                    rowData[VoucherEnum[col][col]] = new Decimal(cell.v).toNumber();
                                } else if (VoucherEnum[col][col] === "lineExtensionAmount" && (typeof cell.v === 'number')) {
                                    rowData[VoucherEnum[col][col]] = new Decimal(new Decimal(cell.v).toFixed(2)).toNumber();
                                } else if (VoucherEnum[col][col] === "borsaAmount") {
                                    if (typeof cell.v === 'number') {
                                        rowData[VoucherEnum[col][col]] = new Decimal(new Decimal(cell.v).toFixed(2)).toNumber();
                                    } else if (row != 0 && cell.v) {
                                        error = error + " <strong>" + (row + 1) + ". satırdaki 'BORSA_TES_UC_TUTARI' harf barındıramaz</strong><br/>";
                                    }
                                } else if (VoucherEnum[col][col] === "meraAmount") {
                                    if (typeof cell.v === 'number') {
                                        rowData[VoucherEnum[col][col]] = new Decimal(new Decimal(cell.v).toFixed(2)).toNumber();
                                    } else if (row != 0 && cell.v) {
                                        error = error + " <strong>" + (row + 1) + ". satırdaki 'MERA_FONU_TUTARI'harf barındıramaz </strong><br/>";
                                    }
                                } else if (VoucherEnum[col][col] === "sgkAmount") {
                                    if (typeof cell.v === 'number') {
                                        rowData[VoucherEnum[col][col]] = new Decimal(new Decimal(cell.v).toFixed(2)).toNumber();
                                    } else if (row != 0 && cell.v) {
                                        error = error + " <strong>" + (row + 1) + ". satırdaki 'SGK_PRIM_KESİNTİ_TUTARI' harf barındıramaz </strong><br/>";
                                    }
                                }  else if (VoucherEnum[col][col] === "unit") {
                                    rowData[VoucherEnum[col][col]] = cell.v;
                                }else if (VoucherEnum[col][col] === "gvStoppageCode") {
                                    rowData[VoucherEnum[col][col]] =  cell.v;
                                }
                            }
                        }
                        rowDataList.push(rowData);
                    }
                }
            }
            if (!headerControl) {
                error = error + " <strong> Doküman içerisinde zorunlu başlık alanları hatalı. Dokümanı kontrol ediniz.</strong><br/>";
            }
            let rowDataListCopy = rowDataList;
            rowDataList.map((rowData, index) => {
                if (rowData.borsaAmount >= 0) {
                    rowDataListCopy.map((rowDataCopy) => {
                        if ((rowData.documentNo === rowDataCopy.documentNo) && !rowDataCopy.borsaAmount) {
                            rowDataCopy["borsaAmount"] = new Decimal(new Decimal(0).toFixed(2)).toNumber();
                        }
                    });
                }
                if (rowData.meraAmount >= 0) {
                    rowDataListCopy.map((rowDataCopy) => {
                        if ((rowData.documentNo === rowDataCopy.documentNo) && !rowDataCopy.meraAmount) {
                            rowDataCopy["meraAmount"] = new Decimal(new Decimal(0).toFixed(2)).toNumber();
                        }
                    });
                }
                if (rowData.sgkAmount >= 0) {
                    rowDataListCopy.map((rowDataCopy) => {
                        if ((rowData.documentNo === rowDataCopy.documentNo) && !rowDataCopy.sgkAmount) {
                            rowDataCopy["sgkAmount"] = new Decimal(new Decimal(0).toFixed(2)).toNumber();
                        }
                    });
                }

            });
            rowDataList = rowDataListCopy
            rowDataList.map((rowData, row) => {
                let controlObject = 1;
                let voucherValidation = GetEnumDataAndValidation.voucherValidation(rowData, row, controlObject);
                controlObject = voucherValidation.controlObject;
                error = error + voucherValidation.error;
                documentShowCrack.push(rowData);
                if(!controlObject){
                    documentFailed.push(rowData["documentNo"]);
                }
                if(!documentFailed.includes(rowData["documentNo"])){
                    documentShowCrack[index].successful = "Başarılı";
                    index++;
                    if ((rowData && Object.keys(rowData).length >= 10 && rowData && Object.keys(rowData).length <= 16) && row != 0 && controlObject) {
                        let newVoucher = defaultVoucher(rowData,stoppageTypes);
                        if (!(Object.keys(documentListCrack).includes(newVoucher[0].toString()))) {
                            documentListCrack[newVoucher[0]] = newVoucher[1];
                        } else if (Object.keys(documentListCrack).includes(newVoucher[0].toString())) {
                            let OldVoucher = documentListCrack[newVoucher[0]];
                            OldVoucher.trdDocVoucherLines.push(newVoucher[1].trdDocVoucherLines[0]);
                            documentListCrack[newVoucher[0]] = OldVoucher;
                        }
                    }
                } else {
                    if(error.includes("TCKN_VKN")){
                        documentShowCrack[index].successful = "Hatalı TCKN / VKN";
                        index++;
                    }else {
                        documentShowCrack[index].successful = "Hatalı Stopaj Kodu";
                        index++;
                    }
                }
            });

            documentList = Object.values(documentListCrack);
            documentShow = Object.values(documentShowCrack);

            for (let i = 0; i < documentList.length; i++) {
                let voucher = documentList[i];
                for (let j = 0; j < voucher.trdDocVoucherLines.length; j++) {
                    voucher.trdDocVoucherLines[j] = VoucherLines.calculate(voucher.trdDocVoucherLines[j],true);
                }
                documentList[i] = CreateEditVoucher.calculateTotal(documentList[i]);
            }

            let xdex = 0;
            for(let i = 1 ; i < (documentShow.length); i++){
                if(documentShow && documentShow[i] && documentShow[i].successful && documentShow[i].successful === "Başarılı" && documentList.length > 0){
                    documentShow[i].payableAmount = documentList[xdex].payableAmount;
                    xdex++;
                    if(documentShow[i+1] && documentShow[i+1].documentNo && documentShow[i].documentNo === documentShow[i+1].documentNo){
                        xdex--;
                    }
                } else if (documentShow && documentShow[i]) {
                    documentShow[i].payableAmount = null;
                }
            }

            let documentCopy = ["Check"];

            for(let i = 1 ; i < documentShow.length; i++){
                if(!documentCopy.includes(documentShow[i].documentNo)){
                    excelDatas.push({
                        issueDate: moment(documentShow[i].issueDate,"DD-MM-YYYY HH:mm:ss"),
                        documentNo: documentShow[i].documentNo,
                        vknTckn: documentShow[i].vknTckn,
                        fullName: documentShow[i].fullName,
                        stockCode: documentShow[i].stockCode,
                        //givenName: documentList.externalCustomer.givenName,
                        //familyName: documentList.externalCustomer.familyName,
                        //formattedName: documentList.externalCustomer.formattedName,
                        payableAmount: documentShow[i].lineExtensionAmount,
                        successful: documentShow[i].successful
                    })
                }
                documentCopy.push(documentShow[i].documentNo);
            }

        } else {
            error = error + " <strong> Boş bir doküman yüklediniz.</strong><br/>";
        }
        self.setState({
            documentList: documentList,
            processingExcel: false,
            excelDatas: excelDatas,
            uploadBtnDisabled: false
        });

        if (error) {
            Alert.closeAll();
            Alert.info(error, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 8000
            });
        }
    }

    async sVoucherToDocumentList(fileContent) {
        let self = this;
        let workbook = XLSX.read(fileContent, {type: "array"});
        let sheet = workbook.Sheets[workbook.SheetNames[0]];
        let documentList = [];
        let documentListCrack = {};
        let excelDatas = [];
        let documentFailed = ["Check"];
        let documentShow = [];
        let documentShowCrack =[];
        let index = 0;
        let error = "";
        let sVoucherEnum = [];
        if (sheet["!ref"] != null) {
            let sheetcopy = sheet;
            let range = XLSX.utils.decode_range(sheet["!ref"]);
            let rowLength = XLSX.utils.decode_range(sheet["!ref"]);
            sVoucherEnum = GetEnumDataAndValidation.getSVoucherEnum(sheetcopy, rowLength);
            let headerControl = GetEnumDataAndValidation.getHeaderSVoucherValidation(sVoucherEnum);
            for (let row = range.s.r; row <= range.e.r; row++) {
                if (row > -1) {
                    let rowData = {};
                    if (((range.e.c + 1) >= 14) && headerControl) {
                        for (let col = range.s.c; col <= range.e.c; col++) {
                            let cell = sheet[XLSX.utils.encode_cell({r: row, c: col})];
                            if (cell !== undefined) {
                                if (sVoucherEnum[col][col] === "issueDate") {
                                    if (!cell.v) {
                                        let dateTime = XLSX.SSF.parse_date_code(cell.v);
                                        rowData[sVoucherEnum[col][col]] = this.pad(dateTime.y) + "-" + this.pad(dateTime.m) + "-" + dateTime.d + "T" + this.pad(dateTime.H) + ":" + this.pad(dateTime.M) + ":" + this.pad(dateTime.S);
                                    } else {
                                        rowData[sVoucherEnum[col][col]] = (cell.w ? (cell.w).replace(new RegExp("/", 'g'), "-") : cell.w);
                                    }
                                } else if (sVoucherEnum[col][col] === "vknTckn") {
                                    rowData[sVoucherEnum[col][col]] = cell.v;
                                } else if (sVoucherEnum[col][col] === "itemName" && (typeof cell.v === 'string')) {
                                    rowData[sVoucherEnum[col][col]] = cell.v;
                                } else if (sVoucherEnum[col][col] === "documentNo") {
                                    rowData[sVoucherEnum[col][col]] = cell.v;
                                } else if (sVoucherEnum[col][col] === "formattedName") {
                                    rowData[sVoucherEnum[col][col]] = cell.v;
                                } else if (sVoucherEnum[col][col] === "givenName") {
                                    rowData[sVoucherEnum[col][col]] = cell.v;
                                } else if (sVoucherEnum[col][col] === "familyName" && (typeof cell.v === 'string')) {
                                    rowData[sVoucherEnum[col][col]] = cell.v;
                                } else if (sVoucherEnum[col][col] === "citySubdivisionName" && (typeof cell.v === 'string')) {
                                    rowData[sVoucherEnum[col][col]] = cell.v;
                                } else if (sVoucherEnum[col][col] === "cityName" && (typeof cell.v === 'string')) {
                                    rowData[sVoucherEnum[col][col]] = cell.v;
                                } else if (sVoucherEnum[col][col] === "tevkifatAmount") {
                                    rowData[sVoucherEnum[col][col]] = new Decimal(new Decimal(parseFloat(cell.v)).toFixed(2)).toNumber();
                                } else if (sVoucherEnum[col][col] === "gercekAmount") {
                                    rowData[sVoucherEnum[col][col]] = new Decimal(new Decimal(parseFloat(cell.v)).toFixed(2)).toNumber();
                                } else if (sVoucherEnum[col][col] === "gvStoppageCode") {
                                    rowData[sVoucherEnum[col][col]] = cell.v;
                                } else if (sVoucherEnum[col][col] === "lineExtensionAmount") {
                                    rowData[sVoucherEnum[col][col]] = new Decimal(new Decimal(parseFloat(cell.v)).toFixed(2)).toNumber();
                                } else if (sVoucherEnum[col][col] === "note") {
                                    rowData[sVoucherEnum[col][col]] = cell.v;
                                } else if (sVoucherEnum[col][col] === "percentage") {
                                    rowData[sVoucherEnum[col][col]] = cell.v;
                                }
                            }
                        }
                        let controlObject = 1;
                        let sVoucherValidation = GetEnumDataAndValidation.sVoucherValidation(rowData, row, controlObject);
                        controlObject = sVoucherValidation.controlObject;
                        error = error + sVoucherValidation.error;
                        rowData = GetEnumDataAndValidation.setName(rowData, controlObject, row);
                        documentShowCrack.push(rowData);
                        if(!controlObject){
                            documentFailed.push(rowData["documentNo"]);
                        }
                        if(!documentFailed.includes(rowData["documentNo"])) {
                            documentShowCrack[index].successful = "Başarılı";
                            index++;
                            if (rowData && Object.keys(rowData).length >= 13 && row != 0 && controlObject) {
                                let stoppageTypes = await this.getStoppageTypes();
                                let newVoucher = defaultSVoucher(rowData, stoppageTypes);
                                if (!(Object.keys(documentListCrack).includes(newVoucher[0].toString()))) {
                                    documentListCrack[newVoucher[0]] = newVoucher[1];
                                    documentListCrack[newVoucher[0]].documentNo = newVoucher[0];
                                } else if (Object.keys(documentListCrack).includes(newVoucher[0].toString())) {
                                    let OldVoucher = documentListCrack[newVoucher[0]];
                                    OldVoucher.trdDocVoucherLines.push(newVoucher[1].trdDocVoucherLines[0]);
                                    documentListCrack[newVoucher[0]] = OldVoucher;
                                    documentListCrack[newVoucher[0]].documentNo = newVoucher[0];
                                }
                            }
                        } else {
                            if(error.includes("TCKN_VKN")){
                                documentShowCrack[index].successful = "Hatalı TCKN / VKN";
                                index++;
                            }else {
                                documentShowCrack[index].successful = "Hatalı Stopaj Kodu";
                                index++;
                            }

                        }
                    }
                }
            }
            if (!headerControl) {
                error = error + " <strong> Doküman içerisinde zorunlu başlık alanları hatalı. Dokümanı kontrol ediniz.</strong><br/>";
            }

            documentList = Object.values(documentListCrack);
            documentShow = Object.values(documentShowCrack);
            for (let i = 0; i < documentList.length; i++) {
                let voucher = documentList[i];
                for (let j = 0; j < voucher.trdDocVoucherLines.length; j++) {
                    voucher.trdDocVoucherLines[j] = VoucherLines.calculate(voucher.trdDocVoucherLines[j],false);
                }
                documentList[i] = CreateEditVoucher.calculateTotal(documentList[i]);
            }

            let xdex = 0;
            for(let i = 1 ; i < (documentShow.length); i++){
                if(documentShow && documentShow[i] && documentShow[i].successful && documentShow[i].successful === "Başarılı" && documentList.length > 0){
                    documentShow[i].payableAmount = documentList[xdex].payableAmount;
                    xdex++;
                    if(documentShow[i+1] && documentShow[i+1].documentNo && documentShow[i].documentNo === documentShow[i+1].documentNo){
                        xdex--;
                    }
                } else if (documentShow && documentShow[i]) {
                    documentShow[i].payableAmount = null;
                }
            }
            let documentCopy = ["Check"];

            for(let i = 1 ; i < documentShow.length; i++){
                if(!documentCopy.includes(documentShow[i].documentNo)){
                    excelDatas.push({
                        issueDate: moment(documentShow[i].issueDate,"DD-MM-YYYY HH:mm:ss"),
                        documentNo: documentShow[i].documentNo,
                        vknTckn: documentShow[i].vknTckn,
                        fullName: documentShow[i].fullName,
                        //givenName: documentList.externalCustomer.givenName,
                        //familyName: documentList.externalCustomer.familyName,
                        //formattedName: documentList.externalCustomer.formattedName,
                        payableAmount: documentShow[i].payableAmount,
                        successful: documentShow[i].successful
                    })
                }
                documentCopy.push(documentShow[i].documentNo);
            }
        } else {
            error = error + " <strong> Boş bir doküman yüklediniz.</strong><br/>";
        }
        self.setState({
            documentList: documentList,
            processingExcel: false,
            excelDatas: excelDatas,
            uploadBtnDisabled: false
        });
        if (error) {
            Alert.closeAll();
            Alert.info(error, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 8000
            });
        }
    }

    despatchToDocumentList(fileContent) {
        let self = this;
        let workbook = XLSX.read(fileContent, {type: "array"});
        let sheet = workbook.Sheets[workbook.SheetNames[0]];
        let documentListCrack = {};
        let documentList = [];
        let excelDatas = [];
        let error = "";
        let despatchEnum = [];
        let notes = [];
        let failed = [];
        if (sheet["!ref"] != null) {
            let range = XLSX.utils.decode_range(sheet["!ref"]);
            let sheetcopy = sheet;
            let rowLength = XLSX.utils.decode_range(sheet["!ref"]);
            despatchEnum = GetEnumDataAndValidation.getDespatchEnum(sheetcopy, rowLength);
            let headerControl = GetEnumDataAndValidation.getHeaderDespatchValidation(despatchEnum);
            for (let row = range.s.r; row <= range.e.r; row++) {
                if (row > -1) {
                    let rowData = {};
                    if (((range.e.c + 1) >= 27) && headerControl) {
                        for (let col = range.s.c; col <= range.e.c; col++) {
                            let cell = sheet[XLSX.utils.encode_cell({r: row, c: col})];
                            if (cell !== undefined) {
                                if (despatchEnum[col][col] === "issueDate") {
                                    if (!cell.v) {
                                        let dateTime = XLSX.SSF.parse_date_code(cell.v);
                                        rowData[despatchEnum[col][col]] = this.pad(dateTime.y) + "-" + this.pad(dateTime.m) + "-" + dateTime.d;
                                    } else {
                                        rowData[despatchEnum[col][col]] = (cell.w ? (cell.w).replace(new RegExp("/", 'g'), "-") : cell.w);
                                    }
                                } else if (despatchEnum[col][col] === "issueTime") {
                                    rowData[despatchEnum[col][col]] = cell.w;
                                } else if (despatchEnum[col][col] === "documentNo") {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "givenName" && (typeof cell.v === 'string')) {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "familyName" && (typeof cell.v === 'string')) {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "vknTckn") {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "cityName" && (typeof cell.v === 'string')) {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "citySubdivisionName" && (typeof cell.v === 'string')) {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "postboxAlias") {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "sourceUrn") {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "issueDate") {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "formattedName" && (typeof cell.v === 'string')) {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "deliveryStreetName" && (typeof cell.v === 'string')) {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "deliveryPostalZone") {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "deliveryCitySubdivision" && (typeof cell.v === 'string')) {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "deliveryCity" && (typeof cell.v === 'string')) {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "deliveryType" && (typeof cell.v === 'string')) {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "carrierId") {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "carrierTitle") {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "driverFirstName" && (typeof cell.v === 'string')) {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "driverFamilyName" && (typeof cell.v === 'string')) {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "licensePlateID") {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "streetName") {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "orderReferenceNumber") {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "orderReferenceDate") {
                                    if (!cell.v) {
                                        let dateTime = XLSX.SSF.parse_date_code(cell.v);
                                        rowData[despatchEnum[col][col]] = this.pad(dateTime.y) + "-" + this.pad(dateTime.m) + "-" + dateTime.d;
                                    } else {
                                        rowData[despatchEnum[col][col]] = (cell.w ? (cell.w).replace(new RegExp("/", 'g'), "-") : cell.w);
                                    }
                                } else if (despatchEnum[col][col] === "actualDespatchDatetime") {
                                    if (!cell.v) {
                                        let dateTime = XLSX.SSF.parse_date_code(cell.v);
                                        rowData[despatchEnum[col][col]] = this.pad(dateTime.y) + "-" + this.pad(dateTime.m) + "-" + dateTime.d;
                                    } else {
                                        rowData[despatchEnum[col][col]] = (cell.w ? (cell.w).replace(new RegExp("/", 'g'), "-") : cell.w);
                                    }
                                } else if (despatchEnum[col][col] === "actualDespatchDatehour") {
                                    if (!cell.v) {
                                        let dateTime = XLSX.SSF.parse_date_code(cell.v);
                                        rowData[despatchEnum[col][col]] = this.pad(dateTime.y) + "-" + this.pad(dateTime.m) + "-" + dateTime.d;
                                    } else {
                                        rowData[despatchEnum[col][col]] = (cell.w ? (cell.w).replace(new RegExp("/", 'g'), "-") : cell.w);
                                    }
                                } else if (despatchEnum[col][col] === "itemName") {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "quantity") {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "unit") {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "unitPrice") {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                } else if (despatchEnum[col][col] === "note") {
                                    rowData[despatchEnum[col][col]] = cell.v;
                                }
                            }
                        }

                        let controlObject = 1;
                        let despatchValidation = GetEnumDataAndValidation.despatchValidation(rowData, row, controlObject);
                        controlObject = despatchValidation.controlObject;
                        error = error + despatchValidation.error;
                        rowData = GetEnumDataAndValidation.setName(rowData, controlObject, row);
                        if(!controlObject && row !== 0){
                            failed.push(rowData["documentNo"]);
                        }
                        if (rowData && Object.keys(rowData).length <= 31 && row !== 0 && controlObject) {
                            let newDespatch = defaultDespatch(rowData);
                            if (!(Object.keys(documentListCrack).includes(newDespatch[0].toString()))) {
                                notes.push(newDespatch[1].despatchNotes[0].note);
                                documentListCrack[newDespatch[0]] = newDespatch[1];
                                excelDatas.push(rowData);
                                documentListCrack[newDespatch[0]].documentNo = rowData["documentNo"];
                            } else if (Object.keys(documentListCrack).includes(newDespatch[0].toString())) {
                                let OldDespatch = documentListCrack[newDespatch[0]];
                                if( OldDespatch.despatchNotes[0].note !== newDespatch[1].despatchNotes[0].note && !notes.includes(newDespatch[1].despatchNotes[0].note)){
                                    OldDespatch.despatchNotes[0].note = OldDespatch.despatchNotes[0].note + '\n' + newDespatch[1].despatchNotes[0].note;
                                }
                                OldDespatch.despatchLines.push(newDespatch[1].despatchLines[0]);
                                notes.push(newDespatch[1].despatchNotes[0].note);
                                documentListCrack[newDespatch[0]] = OldDespatch;
                                documentListCrack[newDespatch[0]].documentNo = rowData["documentNo"];
                            }
                        }
                    }
                }
            }

            if (!headerControl) {
                error = error + " <strong> Doküman içerisinde zorunlu başlık alanları hatalı. Dokümanı kontrol ediniz.</strong><br/>";
            }
            documentList = Object.values(documentListCrack);
            documentList = documentList.filter(f=>!failed.includes(f.documentNo));
            excelDatas   = excelDatas.filter(f=>!failed.includes(f.documentNo));

            for (let i = 0; i < documentList.length; i++) {
                let despatch = documentList[i];
                for (let j = 0; j < despatch.despatchLines.length; j++) {
                    despatch.despatchLines[j] = DespatchLines.calculate(despatch.despatchLines[j]);
                }
                let data = deepCopyObject(documentList[i]);
                let despatchLines = data.despatchLines;
                let lineExtensionTotalAmount = new Decimal(0.00);
                for (let i = 0; i < despatchLines.length; i++) {
                    let despatchLine = despatchLines[i];
                    lineExtensionTotalAmount = lineExtensionTotalAmount.add(new Decimal(despatchLine.lineExtensionAmount));
                }
                data.payableAmount = new Decimal(lineExtensionTotalAmount.toFixed(2)).toNumber();
                data.lineExtensionAmount = new Decimal(lineExtensionTotalAmount.toFixed(2)).toNumber();
                documentList[i] = data;
            }
        } else {
            error = error + " <strong> Boş bir doküman yüklediniz.</strong><br/>";
        }
        self.setState({
            documentList: documentList,
            processingExcel: false,
            excelDatas: excelDatas,
            uploadBtnDisabled: false
        });
        if (error) {
            Alert.closeAll();
            Alert.info(error, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 8000
            });
        }
    }

    stockToDocumentList(fileContent) {
        let self = this;
        let workbook = XLSX.read(fileContent, {type: "array"});
        let sheet = workbook.Sheets[workbook.SheetNames[0]];
        let documentListCrack = {};
        let documentList = [];
        let excelDatas = [];
        let error = "";
        let stockEnum = [];
        if (sheet["!ref"] != null) {
            let range = XLSX.utils.decode_range(sheet["!ref"]);
            let sheetcopy = sheet;
            let rowLength = XLSX.utils.decode_range(sheet["!ref"]);
            stockEnum = GetEnumDataAndValidation.getStockEnum(sheetcopy, rowLength);
            let headerControl = GetEnumDataAndValidation.getHeaderStockValidation(stockEnum);
            for (let row = range.s.r; row <= range.e.r; row++) {
                if (row > -1) {
                    let rowData = {};
                    if (((range.e.c + 1) >= 13) && headerControl) {
                        for (let col = range.s.c; col <= range.e.c; col++) {
                            let cell = sheet[XLSX.utils.encode_cell({r: row, c: col})];
                            if (cell !== undefined) {
                                if (stockEnum[col][col] === "stockCode") {
                                    rowData[stockEnum[col][col]] = cell.v;
                                } else if (stockEnum[col][col] === "stockName") {
                                    rowData[stockEnum[col][col]] = cell.v;
                                } else if (stockEnum[col][col] === "kdvBuy") {
                                    rowData[stockEnum[col][col]] = cell.v;
                                } else if (stockEnum[col][col] === "kdvSell") {
                                    rowData[stockEnum[col][col]] = cell.v;
                                } else if (stockEnum[col][col] === "priceBuy") {
                                    rowData[stockEnum[col][col]] = cell.v;
                                } else if (stockEnum[col][col] === "priceSell") {
                                    rowData[stockEnum[col][col]] = cell.v;
                                } else if (stockEnum[col][col] === "currency") {
                                    rowData[stockEnum[col][col]] = cell.v;
                                } else if (stockEnum[col][col] === "unit") {
                                    rowData[stockEnum[col][col]] = cell.v;
                                } else if (stockEnum[col][col] === "alias") {
                                    rowData[stockEnum[col][col]] = cell.v;
                                } else if (stockEnum[col][col] === "explanation") {
                                    rowData[stockEnum[col][col]] = cell.v;
                                } else if (stockEnum[col][col] === "kdvPurchaseExemption") {
                                    rowData[stockEnum[col][col]] = cell.v;
                                } else if (stockEnum[col][col] === "kdvSellExemption") {
                                    rowData[stockEnum[col][col]] = cell.v;
                                } else if (stockEnum[col][col] === "gtip") {
                                    rowData[stockEnum[col][col]] = cell.v;
                                }
                            } else {
                                if (stockEnum[col][col] === "kdvPurchaseExemption") {
                                    rowData[stockEnum[col][col]] = "";
                                } else if (stockEnum[col][col] === "kdvSellExemption") {
                                    rowData[stockEnum[col][col]] = "";
                                }
                            }
                        }
                        let controlObject = 1;
                        let stockValidation = GetEnumDataAndValidation.stockValidation(rowData, row, controlObject);
                        controlObject = stockValidation.controlObject;
                        error = error + stockValidation.error;
                        if (rowData && Object.keys(rowData).length >= 10 && row != 0 && controlObject) {
                            let newStock = defaultStock(rowData);
                            documentListCrack[newStock[0]] = newStock[1];
                            excelDatas.push(rowData);
                            documentList.push(newStock[0]);
                        }
                    }
                }
            }
            if (!headerControl) {
                error = error + " <strong> Doküman içerisinde zorunlu başlık alanları hatalı. Dokümanı kontrol ediniz.</strong><br/>";
            }
        } else {
            error = error + " <strong> Boş bir doküman yüklediniz.</strong><br/>";
        }
        self.setState({
            documentList: documentList,
            processingExcel: false,
            excelDatas: excelDatas,
            uploadBtnDisabled: false
        });
        if (error) {
            Alert.closeAll();
            Alert.info(error, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 8000
            });
        }
    }

    sigortaToDocumentList(fileContent) {
        let self = this;
        let workbook = XLSX.read(fileContent, {type: "array"});
        let sheet = workbook.Sheets[workbook.SheetNames[0]];
        let documentListCrack = {};
        let documentList = [];
        let excelDatas = [];
        let error = "";
        let sigortaEnum = [];
        let notes = [];
        let failed = [];
        if (sheet["!ref"] != null) {
            let range = XLSX.utils.decode_range(sheet["!ref"]);
            let sheetcopy = sheet;
            let rowLength = XLSX.utils.decode_range(sheet["!ref"]);
            sigortaEnum = GetEnumDataAndValidation.getSigortaEnum(sheetcopy, rowLength);
            let headerControl = GetEnumDataAndValidation.getHeaderSigortaValidation(sigortaEnum);
            for (let row = range.s.r; row <= range.e.r; row++) {
                if (row > -1) {
                    let rowData = {};
                    if (((range.e.c + 1) >= 21) && headerControl) {
                        for (let col = range.s.c; col <= range.e.c; col++) {
                            let cell = sheet[XLSX.utils.encode_cell({r: row, c: col})];
                            if (cell !== undefined) {
                                if (sigortaEnum[col][col] === "issueDate") {
                                    if (!cell.v) {
                                        let dateTime = XLSX.SSF.parse_date_code(cell.v);
                                        rowData[sigortaEnum[col][col]] = this.pad(dateTime.y) + "-" + this.pad(dateTime.m) + "-" + dateTime.d;
                                    } else {
                                        rowData[sigortaEnum[col][col]] = (cell.w ? (cell.w).replace(new RegExp("/", 'g'), "-") : cell.w);
                                    }
                                } else if (sigortaEnum[col][col] === "issueTime") {
                                    rowData[sigortaEnum[col][col]] = cell.w;
                                } else if (sigortaEnum[col][col] === "documentNo") {
                                    rowData[sigortaEnum[col][col]] = cell.v;
                                } else if (sigortaEnum[col][col] === "documentCurrencyCode") {
                                    rowData[sigortaEnum[col][col]] = cell.v;
                                } else if (sigortaEnum[col][col] === "paymentExchangeRate") {
                                    rowData[sigortaEnum[col][col]] = cell.v;
                                } else if (sigortaEnum[col][col] === "givenName" && (typeof cell.v === 'string')) {
                                    rowData[sigortaEnum[col][col]] = cell.v;
                                } else if (sigortaEnum[col][col] === "formattedName" && (typeof cell.v === 'string')) {
                                    rowData[sigortaEnum[col][col]] = cell.v;
                                } else if (sigortaEnum[col][col] === "familyName" && (typeof cell.v === 'string')) {
                                    rowData[sigortaEnum[col][col]] = cell.v;
                                } else if (sigortaEnum[col][col] === "vknTckn") {
                                    rowData[sigortaEnum[col][col]] = cell.v;
                                }  else if (sigortaEnum[col][col] === "postboxAlias") {
                                    rowData[sigortaEnum[col][col]] = cell.v;
                                } else if (sigortaEnum[col][col] === "cityName" && (typeof cell.v === 'string')) {
                                    rowData[sigortaEnum[col][col]] = cell.v;
                                } else if (sigortaEnum[col][col] === "citySubdivisionName" && (typeof cell.v === 'string')) {
                                    rowData[sigortaEnum[col][col]] = cell.v;
                                } else if (sigortaEnum[col][col] === "countryName" && (typeof cell.v === 'string')) {
                                    rowData[sigortaEnum[col][col]] = cell.v;
                                } else if (sigortaEnum[col][col] === "streetName") {
                                    rowData[sigortaEnum[col][col]] = cell.v;
                                } else if (sigortaEnum[col][col] === "taxOffice") {
                                    rowData[sigortaEnum[col][col]] = cell.v;
                                } else if (sigortaEnum[col][col] === "itemName") {
                                    rowData[sigortaEnum[col][col]] = cell.v;
                                }else if (sigortaEnum[col][col] === "productCommissionPrice") {
                                    rowData[sigortaEnum[col][col]] = cell.v;
                                } else if (sigortaEnum[col][col] === "cancelCommissionPrice") {
                                    rowData[sigortaEnum[col][col]] = cell.v;
                                }else if (sigortaEnum[col][col] === "periodStartDateTime") {
                                    rowData[sigortaEnum[col][col]] = cell.v;
                                } else if (sigortaEnum[col][col] === "periodEndDateTime") {
                                    rowData[sigortaEnum[col][col]] = cell.v;
                                }else if (sigortaEnum[col][col] === "note") {
                                    rowData[sigortaEnum[col][col]] = cell.v;
                                }
                            }
                        }

                        let controlObject = 1;
                        let sigortaValidation = GetEnumDataAndValidation.sigortaValidation(rowData, row, controlObject);
                        controlObject = sigortaValidation.controlObject;
                        error = error + sigortaValidation.error;
                        rowData = GetEnumDataAndValidation.setName(rowData, controlObject, row);
                        if(!controlObject && row !== 0){
                            failed.push(rowData["documentNo"]);
                        }
                        if (rowData && Object.keys(rowData).length <= 31 && row !== 0 && controlObject) {
                            let newSigorta = defaultSigorta(rowData);
                            if (!(Object.keys(documentListCrack).includes(newSigorta[0].toString()))) {
                                notes.push(newSigorta[1].trdDocSigortaNotes[0].note);
                                documentListCrack[newSigorta[0]] = newSigorta[1];
                                excelDatas.push(rowData);
                                documentListCrack[newSigorta[0]].documentNo = rowData["documentNo"];
                            } else if (Object.keys(documentListCrack).includes(newSigorta[0].toString())) {
                                let OldSigorta = documentListCrack[newSigorta[0]];
                                if( OldSigorta.not[0].note !== newSigorta[1].trdDocSigortaNotes[0].note && !notes.includes(newSigorta[1].trdDocSigortaNotes[0].note)){
                                    OldSigorta.trdDocSigortaNotes[0].note = OldSigorta.trdDocSigortaNotes[0].note + '\n' + newSigorta[1].trdDocSigortaNotes[0].note;
                                }
                                OldSigorta.despatchLines.push(newSigorta[1].despatchLines[0]);
                                notes.push(newSigorta[1].trdDocSigortaNotes[0].note);
                                documentListCrack[newSigorta[0]] = OldSigorta;
                                documentListCrack[newSigorta[0]].documentNo = rowData["documentNo"];
                            }
                        }
                    }
                }
            }

            if (!headerControl) {
                error = error + " <strong> Doküman içerisinde zorunlu başlık alanları hatalı. Dokümanı kontrol ediniz.</strong><br/>";
            }
            documentList = Object.values(documentListCrack);
            documentList = documentList.filter(f=>!failed.includes(f.documentNo));
            excelDatas = excelDatas.filter(f => !failed.includes(f.documentNo));
            for (let i = 0; i < documentList.length; i++) {
                let sigorta = documentList[i];
                let data = deepCopyObject(documentList[i]);
                let trdDocSigortaLines = data.trdDocSigortaLines;
                let lineExtensionTotalAmount = new Decimal(0.00);
                data.payableAmount = new Decimal(0.00);
                data.lineExtensionAmount = new Decimal(0.00);
                data.taxInclusiveAmount = new Decimal(0.00);
                data.taxExclusiveAmount = new Decimal(0.00);
                data.lineExtensionAmount = new Decimal(0.00);
                documentList[i] = data;
            }

        } else {
            error = error + " <strong> Boş bir doküman yüklediniz.</strong><br/>";
        }
        self.setState({
            documentList: documentList,
            processingExcel: false,
            excelDatas: excelDatas,
            uploadBtnDisabled: false
        });
        if (error) {
            Alert.closeAll();
            Alert.info(error, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 8000
            });
        }
    }

    async externalCustomerToDocumentList(fileContent) {
        let self = this;
        let workbook = XLSX.read(fileContent, {type: "array"});
        let sheet = workbook.Sheets[workbook.SheetNames[0]];
        let documentListCrack = {};
        let documentList = [];
        let excelDatas = [];
        let error = "";
        let externalCustomerEnum = [];
        let controlObjectList = [];
        let controlObjectListCrack = [];
        try {
            if (sheet["!ref"] != null) {
                let range = XLSX.utils.decode_range(sheet["!ref"]);
                let sheetcopy = sheet;
                let rowLength = XLSX.utils.decode_range(sheet["!ref"]);
                externalCustomerEnum = GetEnumDataAndValidation.getExternalCustomerEnum(sheetcopy, rowLength);
                let headerControl = GetEnumDataAndValidation.getHeaderExternalCustomerValidation(externalCustomerEnum);
                let allVknTckns = [];
                let vknTckn = '';
                let formattedName = '';
                let isForeign = '0';
                for (let row = range.s.r; row <= range.e.r; row++) {
                    vknTckn = '';
                    formattedName = '';
                    isForeign = '0';
                    if (row > -1) {
                        let rowData = {};
                        if (((range.e.c + 1) >= 30) && headerControl) {
                            for (let col = range.s.c; col <= range.e.c; col++) {
                                let cell = sheet[XLSX.utils.encode_cell({r: row, c: col})];
                                if (cell !== undefined) {
                                    if (externalCustomerEnum[col][col] === "vkn_tckn") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                        if ((cell.v && cell.v.toString() !== 'VKN/TCKN_(Zorunlu)')) {
                                            vknTckn = cell.v;
                                        }
                                    } else if (externalCustomerEnum[col][col] === "formatted_name") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                        formattedName = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "given_name") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "middle_name") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "family_name") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "commerce_chamber") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "city") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "tax_office") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "mersis_number") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "trade_registration_number") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "customer_type") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "initial_balance") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "customer_risk_limit") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "address_name") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "contact_person") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                        // } else if (externalCustomerEnum[col][col] === "postbox_alias") {
                                        //     rowData[externalCustomerEnum[col][col]] = cell.v;
                                        // } else if (externalCustomerEnum[col][col] === "despatch_postbox_alias") {
                                        //     rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "country_name") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "city_name") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "city_subdivision_name") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "web_site") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "email") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "telephone") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "fax") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "postal_address_region") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "building_name") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "building_no") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "postal_address_room") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "postal_zone") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "bank_name") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "iban") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                    } else if (externalCustomerEnum[col][col] === "is_foreign_customer") {
                                        rowData[externalCustomerEnum[col][col]] = cell.v;
                                        if(rowData[externalCustomerEnum[col][col]].toUpperCase() === "EVET") {
                                            isForeign = "1";
                                        }else{
                                            isForeign = "0";
                                        }
                                    }
                                } else {
                                    if (externalCustomerEnum[col][col] === "vkn_tckn") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "formatted_name") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "given_name") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "middle_name") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "family_name") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "commerce_chamber") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "city") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "tax_office") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "mersis_number") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "trade_registration_number") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "customer_type") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "initial_balance") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "customer_risk_limit") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "address_name") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "contact_person") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                        // } else if (externalCustomerEnum[col][col] === "postbox_alias") {
                                        //     rowData[externalCustomerEnum[col][col]] = "";
                                        // } else if (externalCustomerEnum[col][col] === "despatch_postbox_alias") {
                                        //     rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "country_name") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "city_name") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "city_subdivision_name") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "web_site") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "email") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "telephone") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "fax") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "postal_address_region") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "building_name") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "building_no") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "postal_address_room") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "postal_zone") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "bank_name") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "iban") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    } else if (externalCustomerEnum[col][col] === "is_foreign_customer") {
                                        rowData[externalCustomerEnum[col][col]] = "";
                                    }
                                }
                            }
                            let controlObject = 1;
                            let externalCustomerValidation = GetEnumDataAndValidation.externalCustomerValidation(rowData, row, controlObject);
                            controlObject = externalCustomerValidation.controlObject;
                            error = error + externalCustomerValidation.error;

                            if (rowData && Object.keys(rowData).length === 30 && row !== 0) {
                                let newExternalCustomer = defaultExternalCustomer(rowData);
                                documentListCrack[newExternalCustomer[0]] = newExternalCustomer[1];
                                excelDatas.push(rowData);
                                let isNewExternal = true;
                                for(let i=0; i<documentList.length; i++){
                                    if (documentList[i].vknTckn === newExternalCustomer[0].vknTckn){
                                        documentList[i].externalCustomerAddressList.push(newExternalCustomer[0].externalCustomerAddressList[0]);
                                        isNewExternal = false;
                                    }
                                }
                                if (isNewExternal){
                                    documentList.push(newExternalCustomer[0]);
                                }
                                controlObjectList.push(controlObject);
                            }
                        }
                    }
                    if(vknTckn !== ""){
                        if(isForeign === "0")
                            allVknTckns.push([vknTckn,isForeign]);
                        else
                            allVknTckns.push([formattedName,isForeign]);
                    }
                }

                if (!headerControl) {
                    error = error + " <strong> Doküman içerisinde zorunlu başlık alanları hatalı. Dokümanı kontrol ediniz.</strong><br/>";
                }

                for(let i = 0; i < controlObjectList.length; i++){
                    if(controlObjectList[i] === 0)
                        controlObjectListCrack.push(allVknTckns[i]);
                }

                if (!error && allVknTckns.length !== 0) {
                        let pkData = await fetchAllPkList(allVknTckns);
                        if (pkData && pkData.length > 0) {
                            for (let i = 0; i < allVknTckns.length; i++) {
                                let postboxAlias = pkData.filter(item => item.documentType === "Invoice" && item.identifier === allVknTckns[i][0].toString())[0];
                                let despatchAlias = pkData.filter(item => item.documentType === "DespatchAdvice" && item.identifier === allVknTckns[i][0].toString())[0];
                                documentList[i].externalCustomerAddressList[0].postboxAlias = postboxAlias ? postboxAlias.aliasName : "";
                                documentList[i].externalCustomerAddressList[0].despatchPostboxAlias = despatchAlias ? despatchAlias.aliasName : "";
                                excelDatas[i].postbox_alias = postboxAlias ? postboxAlias.aliasName : "";
                                excelDatas[i].despatch_postbox_alias = despatchAlias ? despatchAlias.aliasName : "";
                            }
                        }
                }

            } else {
                error = error + " <strong> Boş bir doküman yüklediniz.</strong><br/>";
            }

            documentList = documentList.filter(f=>!controlObjectListCrack.includes(f.vknTckn));

            self.setState({
                documentList: documentList,
                processingExcel: false,
                excelDatas: excelDatas,
                uploadBtnDisabled: false,
                controlObjectList: controlObjectList
            });
            if (error) {
                Alert.closeAll();
                Alert.info(error, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 8000
                });
            }
        } catch(err) {
            Alert.closeAll();
            Alert.error("Bir hatayla karşılaşıldı!" + err, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 8000
            });
            self.setState({
                processingExcel: false,
                uploadBtnDisabled: true,
            });
        }
    }

    triggerFileSelect(event) {
        if (this.state.sending !== 1 && this.inputFile.current)
            this.inputFile.current.click()
    }

    removeDocument() {
    }

    sendDocument() {
        let self = this;
        let saveType;
        if (self.props.type === "voucher") {
            saveType = 0;
        } else if (self.props.type === "sVoucher") {
            saveType = 1;
        }
        let params = {
            url: `/voucherTmp/saveMultiple/${saveType}`,
            method: 'post',
            data: self.state.documentList
        };
        self.setState({btnDisabled: true});
        request(params)
            .then(function (response) {
                Alert.closeAll();
                Alert.success("Dokümanlar başarılı şekilde taslağa kaydedildi.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                });
                self.setState({btnDisabled: false, documentList: [], excelDatas: []});
                self.props.toggleModal(false, true);
            }).catch(function (error) {
            self.setState({btnDisabled: false});
            Alert.closeAll();
            showAxiosError(error);
        });
    }

    sendDespatch() {
        let self = this;
        let params = {
            url: `/despatches/saveMultiple`,
            method: 'post',
            data: self.state.documentList
        };
        self.setState({btnDisabled: true});
        request(params)
            .then(function (response) {
                Alert.closeAll();
                Alert.success("Dokümanlar başarılı şekilde taslağa kaydedildi.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                });
                self.setState({btnDisabled: false, documentList: [], excelDatas: []});
                self.props.toggleModal(false, true);
            }).catch(function (error) {
            self.setState({btnDisabled: false});
            Alert.closeAll();
            showAxiosError(error);
        });
    }

    saveNextDocument(index) {
        let self = this;
        this._source = axios.CancelToken.source();
        let documentList = self.state.documentList;
        if(documentList[index].externalCustomer.customerType === null || documentList[index].externalCustomer.customerType === undefined)
            documentList[index].externalCustomer.customerType=2;
        let excelDatas = self.state.excelDatas;
        if (index < documentList.length) {
            let document = documentList[index];
            let params = {
                url: `/${self.props.type}Tmp/saveNextDocument`,
                cancelToken: self._source.token,
                method: 'post',
                data: document
            };
            self.setState({btnDisabled: true});
            request(params)
                .then(function (response) {
                    let excelData = excelDatas[index];
                    excelData.status = "success";
                    excelData.profileId = response.data;
                    excelData.statusText = "Kayıt Başarılı";
                    excelDatas[index] = excelData;
                    self.setState({excelDatas, index: (index + 1)});
                    if (index + 1 < documentList.length) {
                        self.saveNextDocument(index + 1);
                    } else {
                        self.setState({documentList, excelDatas, btnDisabled: false, index: index + 1});
                        self.props.toggleModal(true, true);
                        return;
                    }
                }).catch(function (error) {
                self.setState({btnDisabled: false});
                if (axios.isCancel(error)) {

                } else {
                    let excelData = excelDatas[index];
                    excelData.status = "error";
                    excelData.statusText = error.data;
                    excelDatas[index] = excelData;
                    self.setState({excelDatas, btnDisabled: true, index: (index + 1)});
                    if (index + 1 < documentList.length) {
                        self.saveNextDocument(index + 1);
                    } else {
                        self.setState({btnDisabled: false});
                        self.props.toggleModal(true, true);
                        return;
                    }
                    showAxiosError(error);
                }
            });
        }
    }

    sendBelge(index) {
        let self = this;
        this._source = axios.CancelToken.source();
        let documentList = self.state.documentList;
        let excelDatas = self.state.excelDatas;
        if (index < documentList.length) {
            let document = documentList[index];
            let params = {
                url: `/${self.props.type}Tmp/saveNextDocument`,
                cancelToken: self._source.token,
                method: 'post',
                data: document
            };
            self.setState({btnDisabled: true});
            request(params)
                .then(function (response) {
                    let excelData = excelDatas[index];
                    excelData.status = "success";
                    excelData.profileId = response.data;
                    excelData.statusText = "Kayıt Başarılı";
                    excelDatas[index] = excelData;
                    self.setState({excelDatas, index: (index + 1)});
                    if (index + 1 < documentList.length) {
                        self.sendBelge(index + 1);
                    } else {
                        self.setState({documentList, excelDatas, btnDisabled: false, index: index + 1});
                        self.props.toggleModal(true, true);
                        return;
                    }
                }).catch(function (error) {
                self.setState({btnDisabled: false});
                if (axios.isCancel(error)) {

                } else {
                    let excelData = excelDatas[index];
                    excelData.status = "error";
                    excelData.statusText = error.data;
                    excelDatas[index] = excelData;
                    self.setState({excelDatas, btnDisabled: true, index: (index + 1)});
                    if (index + 1 < documentList.length) {
                        self.sendBelge(index + 1);
                    } else {
                        self.setState({btnDisabled: false});
                        self.props.toggleModal(true, true);
                        return;
                    }
                    showAxiosError(error);
                }
            });
        }
    }

    saveStockList() {
        let self = this;
        let params = {
            url: `/stock/saveMultiple`,
            method: 'post',
            data: self.state.documentList
        };
        self.setState({btnDisabled: true});
        request(params)
            .then(function (response) {
                Alert.closeAll();
                Alert.success("Dokümanlar başarılı şekilde kaydedildi.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                });
                self.setState({btnDisabled: false, documentList: [], excelDatas: []});
                self.props.toggleModal(false, true);
            }).catch(function (error) {
            self.setState({btnDisabled: false});
            Alert.closeAll();
            showAxiosError(error);
        });
    }

    saveSigorta(){
        let self = this;
        let params = {
            url: `/sigorta/saveMultiple`,
            method: 'post',
            data: self.state.documentList
        };
        self.setState({btnDisabled: true});
        request(params)
            .then(function (response) {
                Alert.closeAll();
                Alert.success("Dokümanlar başarılı şekilde taslağa kaydedildi.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                });
                self.setState({btnDisabled: false, documentList: [], excelDatas: []});
                self.props.toggleModal(false, true);
            }).catch(function (error) {
            self.setState({btnDisabled: false});
            Alert.closeAll();
            showAxiosError(error);
        });
    }

    saveExternalCustomerList() {
        let self = this;
        let params = {
            url: `/externalCustomer/saveMultiple`,
            method: 'post',
            data: self.state.documentList
        };
        self.setState({btnDisabled: true});
        request(params)
            .then(function (response) {
                Alert.closeAll();
                Alert.success("Dokümanlar başarılı şekilde kaydedildi.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                });
                self.setState({btnDisabled: false, documentList: [], excelDatas: []});
                self.props.toggleModal(false, true);
            }).catch(function (error) {
            self.setState({btnDisabled: false});
            Alert.closeAll();
            showAxiosError(error);
        });
    }

    sendExceltoBackend(file) {
        let self = this;
        const formData = new FormData();
        const fileBlob = new Blob([file], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});

        formData.append('file', fileBlob, 'uploaded-file.xlsx');
        let params = {
            url: `/externalCustomer/saveFromExcel`,
            method: 'post',
            data: formData
        };
        self.setState({btnDisabled: true});
        request(params)
            .then(function (response) {
                if (response.data) {
                    self.setState({
                        excelDatas: response.data,
                        btnDisabled: false,
                        processingExcel: false,
                        uploadBtnDisabled: false,
                        documentList: response.data
                    });
                }
            }).catch(function (error) {
            {
                Alert.closeAll();
                Alert.error("Bir hatayla karşılaşıldı!" + error.response.data, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 8000
                });
                self.setState({
                    processingExcel: false,
                    btnDisabled: false,
                    uploadBtnDisabled:false,
                });
            }
        });
    }

    stoppageTypesCheck(){

    }

    async exportToExcel(e) {
        let self = this;
        let data;
        let currencyCodes;
        let unitCodes;
        let filename;
        let kdvExemptions;
        let stoppageTypes;
        let withholdingTypes;
        let paymentMethods = [{"1":"KREDIKARTI/BANKAKARTI"},{"1":"EFT/HAVALE"},{"1":"KAPIDAODEME"},{"1":"ODEMEARACISI"},{"1":"DIGER"}];

        if (self.props.type === "sVoucher") {
            data = self.exportSVoucherToExcel();
            filename = "serbest_meslek_makbuz_ornek_" + moment().format("YYYY_mm_dd_HH_mm_ss") + ".xlsx";
        } else if (self.props.type === "stockList") {
            data = self.exportStockToExcel();
            filename = "ürün_hizmet_örnek_" + moment().format("YYYY_mm_dd_HH_mm_ss") + ".xlsx";
        } else if (self.props.type === "externalCustomerList") {
            data = self.exportExternalCustomerToExcel();
            filename = "cari_örnek" + moment().format("YYYY_mm_dd_HH_mm_ss") + ".xlsx";
        } else if (self.props.type === "despatch") {
            data = self.exportDespatchToExcel();
            filename = "irsaliye_ornek_" + moment().format("YYYY_mm_dd_HH_mm_ss") + ".xlsx";
        } else if (self.props.type === "belge") {
            data = self.exportBelgeToExcel();
            filename = "E_Belge_ornek_" + moment().format("YYYY_mm_dd_HH_mm_ss") + ".xlsx";
        }else if(self.props.type === "sigorta"){
            data = self.exportSigortaToExcel();
            filename = "sigorta_örnek_" + moment().format("YYYY_mm_dd_HH_mm_ss") + ".xlsx";
        } else {
            data = self.props.type === "voucher" ? self.exportVoucherToExcel() : self.exportInvoiceToExcel();
            filename = (self.props.type === "voucher" ? "mustahsil_makbuz_ornek_" : "fatura_ornek_") + moment().format("YYYY_mm_dd_HH_mm_ss") + ".xlsx";
        }
        /* make the worksheet */
        let ws = XLSX.utils.json_to_sheet(data, {skipHeader: true});

        /* add to workbook */
        let wb = XLSX.utils.book_new();

        if (self.props.type === "stockList") {
            currencyCodes = await self.exportStockToExcelCurreny();
            unitCodes = await self.exportStockToExcelUnits();
            kdvExemptions = await self.exportExemptionsToExcel();
            let ws2 = XLSX.utils.json_to_sheet(currencyCodes, {skipHeader: true});
            let ws3 = XLSX.utils.json_to_sheet(unitCodes, {skipHeader: true});
            let ws4 = XLSX.utils.json_to_sheet(kdvExemptions, {skipHeader: true});
            XLSX.utils.book_append_sheet(wb, ws, "Şablon");
            XLSX.utils.book_append_sheet(wb, ws2, "Para Birimleri");
            XLSX.utils.book_append_sheet(wb, ws3, "Ürün-Hizmet Birimleri");
            XLSX.utils.book_append_sheet(wb, ws4, "KDV İstisna Sebepleri");
        } else if (self.props.type === "invoice" || self.props.type === "belge"){
            currencyCodes = await self.exportStockToExcelCurreny();
            kdvExemptions = await self.exportExemptionsToExcel();
            unitCodes = await self.exportStockToExcelUnits();
            withholdingTypes = await self.exportWithholdingTypesToExcel();
            let ws2 = XLSX.utils.json_to_sheet(currencyCodes, {skipHeader: true});
            let ws3 = XLSX.utils.json_to_sheet(kdvExemptions, {skipHeader: true});
            let ws4 = XLSX.utils.json_to_sheet(unitCodes, {skipHeader: true});
            let ws5 = XLSX.utils.json_to_sheet(withholdingTypes, {skipHeader: true});
            let ws6 = XLSX.utils.json_to_sheet(paymentMethods, {skipHeader: true});
            XLSX.utils.book_append_sheet(wb, ws, "Şablon");
            XLSX.utils.book_append_sheet(wb, ws2, "Para Birimleri");
            XLSX.utils.book_append_sheet(wb, ws3, "KDV İstisna Sebepleri");
            XLSX.utils.book_append_sheet(wb, ws4, "Ürün-Hizmet Birimleri");
            XLSX.utils.book_append_sheet(wb, ws5, "KDV Tevkifatı Kodları");
            XLSX.utils.book_append_sheet(wb, ws6, "Ödeme Şekli Tipleri");
        } else if (self.props.type === "sVoucher"){
            let list = ["000", "021", "022", "023", "GV STOPAJI KODU"];
            stoppageTypes  = await self.exportStockToExcelStoppageTypes();
            stoppageTypes = stoppageTypes.filter(f=> list.includes(f.stoppageCode ));
            let ws2 = XLSX.utils.json_to_sheet(stoppageTypes, {skipHeader: true});
            XLSX.utils.book_append_sheet(wb, ws, "Şablon");
            XLSX.utils.book_append_sheet(wb, ws2, "GV Stopaj Kodları");
        } else if (self.props.type === "despatch"){
            unitCodes = await self.exportStockToExcelUnits();
            let ws3 = XLSX.utils.json_to_sheet(unitCodes, {skipHeader: true});
            XLSX.utils.book_append_sheet(wb, ws, "Sheet");
            XLSX.utils.book_append_sheet(wb, ws3, "Ürün-Hizmet Birimleri");
        } else if (self.props.type === "voucher"){
            let list = ["000", "091", "092", "093", "094", "095", "096", "GV STOPAJI KODU"];
            stoppageTypes = await self.exportStockToExcelStoppageTypes();
            unitCodes = await self.exportStockToExcelUnits();
            stoppageTypes = stoppageTypes.filter(f=> list.includes(f.stoppageCode ));
            let ws3 = XLSX.utils.json_to_sheet(unitCodes, {skipHeader: true});
            let ws2 = XLSX.utils.json_to_sheet(stoppageTypes, {skipHeader: true});

            XLSX.utils.book_append_sheet(wb, ws, "Sheet");
            XLSX.utils.book_append_sheet(wb, ws2, "GV Stopaj Kodları");
            XLSX.utils.book_append_sheet(wb, ws3, "Ürün-Hizmet Birimleri");
        } else if (self.props.type === "externalCustomerList") {
            let fmt = '@';
            ws.U2.z = fmt;
            ws.U3.z = fmt;
            ws.U4.z = fmt;
            // let wscols = Object.keys(data[0]).map((a, i) => ({ wch: a.toString().length + 2}));
            // ws['!cols'] = wscols;
            XLSX.utils.book_append_sheet(wb, ws, "Sheet");
        } else {
            XLSX.utils.book_append_sheet(wb, ws, "Sheet");
        }

        /* generate an XLSX file */
        XLSX.writeFile(wb, filename);
    }

    exportExternalCustomerToExcel() {
        let data = [];
        data.push({
            vkn_tckn: "VKN/TCKN_(Zorunlu)",
            formatted_name: "Unvan_(Vkn_için_zorunlu)",
            given_name: "Adı_(Tckn_için_zorunlu)",
            middle_name: "Orta_Adı",
            family_name: "Soyadı_(Tckn_için_zorunlu)",
            commerce_chamber: "Ticaret_Odası",
            city: "Vergi_Dairesi_Şehir",
            tax_office: "Vergi_Dairesi",
            mersis_number: "Mersis_No",
            trade_registration_number: "Ticaret_Sicil_No",
            customer_type: "Müşteri_Tipi_(Zorunlu)",
            initial_balance: "Başlangıç_Bakiyesi",
            customer_risk_limit: "Müşteri_Risk_Limiti",
            address_name: "Adres_Adı_(Zorunlu)",
            contact_person: "Yetkili_Kişi",
            // postbox_alias: "E_Fatura_Alıcı_Etiketi_(E_Fatura_için_zorunlu)",
            // despatch_postbox_alias: "E_İrsaliye_Alıcı_Etiketi_(E_İrsaliye_için_zorunlu)",
            country_name: "Ülke_(Zorunlu)",
            city_name: "Şehir_(Zorunlu)",
            city_subdivision_name: "İlçe_(Zorunlu)",
            web_site: "Web_Sitesi",
            email: "E_Posta",
            telephone: "Telefon",
            fax: "Faks",
            postal_address_region: "Mahalle/Cadde",
            building_name: "Bina_Adı",
            building_no: "Bina_No",
            postal_address_room: "Daire_No",
            postal_zone: "Posta_Kodu",
            bank_name: "Banka_Adı",
            iban: "IBAN",
            is_foreign_customer: "Yabancı_Müşteri"
        });
        data.push({
            vkn_tckn: "66699663056",
            formatted_name: "",
            given_name: "Kadir",
            middle_name: "",
            family_name: "İnanır",
            commerce_chamber: "",
            city: "",
            tax_office: "",
            mersis_number: "",
            trade_registration_number: "",
            customer_type: "Satıcı",
            initial_balance: "",
            customer_risk_limit: "",
            address_name: "Merkez",
            contact_person: "",
            //postbox_alias: "mail:urn:defaultpk@myemail.com",
            //despatch_postbox_alias: "",
            country_name: "Türkiye",
            city_name: "İstanbul",
            city_subdivision_name: "Beşiktaş",
            web_site: "",
            email: "",
            telephone: "+905555555555",
            fax: "",
            postal_address_region: "Atatürk Mahallesi Cumhuriyet Sokak",
            building_name: "",
            building_no: "",
            postal_address_room: "",
            postal_zone: "",
            bank_name: "",
            iban: "",
            is_foreign_customer: "Boş ise 'hayır' kabul edilecektir."
        });
        data.push({
            vkn_tckn: "24620126384",
            formatted_name: "",
            given_name: "Ali",
            middle_name: "Kemal",
            family_name: "Sunal",
            commerce_chamber: "",
            city: "",
            tax_office: "",
            mersis_number: "",
            trade_registration_number: "",
            customer_type: "Alıcı",
            initial_balance: "",
            customer_risk_limit: "",
            address_name: "Merkez",
            contact_person: "",
            //postbox_alias: "mail:urn:defaultpk@myemail.com",
            //despatch_postbox_alias: "",
            country_name: "Türkiye",
            city_name: "Ankara",
            city_subdivision_name: "Çankaya",
            web_site: "",
            email: "",
            telephone: "",
            fax: "",
            postal_address_region: "Gazi Mahallesi Atatürk Caddesi",
            building_name: "",
            building_no: "",
            postal_address_room: "",
            postal_zone: "",
            bank_name: "",
            iban: "",
            is_foreign_customer: "hayır"
        });
        data.push({
            vkn_tckn: "2222222222",
            formatted_name: "ThinkPad Software",
            given_name: "Henry",
            middle_name: "",
            family_name: "FORD",
            commerce_chamber: "",
            city: "",
            tax_office: "",
            mersis_number: "",
            trade_registration_number: "",
            customer_type: "Her İkisi",
            initial_balance: "",
            customer_risk_limit: "",
            address_name: "Merkez",
            contact_person: "",
            //postbox_alias: "",
            //despatch_postbox_alias: "mail:urn:defaultpk@myemail.com",
            country_name: "America",
            city_name: "New York",
            city_subdivision_name: "Hell's Kitchen",
            web_site: "",
            email: "",
            telephone: "",
            fax: "",
            postal_address_region: "",
            building_name: "",
            building_no: "",
            postal_address_room: "",
            postal_zone: "",
            bank_name: "",
            iban: "",
            is_foreign_customer: "EVET"
        });
        return data;
    }

    exportStockToExcel() {
        let data = [];
        data.push({
            stockCode: "Ürün-Hizmet_Kodu",
            stockName: "Ürün-Hizmet_Adı",
            kdvBuy: "Kdv_Alış(%)",
            kdvSell: "Kdv_Satış(%)",
            priceBuy: "Birim_Fiyat_Alış",
            priceSell: "Birim_Fiyat_Satış",
            currency: "Para_Birimi",
            unit: "Birim",
            alias: "Ürün-Hizmet_Etiket",
            explanation: "Ürün-Hizmet_Açıklaması",
            kdvPurchaseExemption: "Kdv_Alış_İstisna_Sebebi",
            kdvSellExemption: "Kdv_Satış_İstisna_Sebebi",
            gtip: "Gtip_Numarası"
        });
        data.push({
            stockCode: "123abc",
            stockName: "Sandalye",
            kdvBuy: "20",
            kdvSell: "20",
            priceBuy: "1000",
            priceSell: "1750",
            currency: "TRY",
            unit: "C62",
            alias: "etiket",
            explanation: "Ahşap",
            kdvPurchaseExemption: "",
            kdvSellExemption: "",
            gtip: "123456789102"
        });
        data.push({
            stockCode: "456def",
            stockName: "Kahve",
            kdvBuy: "8",
            kdvSell: "8",
            priceBuy: "300",
            priceSell: "500",
            currency: "TRY",
            unit: "KGM",
            alias: "etiket",
            explanation: "Latte",
            kdvPurchaseExemption: "",
            kdvSellExemption: "",
            gtip: "123456789102"
        });
        data.push({
            stockCode: "789ghj",
            stockName: "Süt",
            kdvBuy: "0",
            kdvSell: "1",
            priceBuy: "60",
            priceSell: "80",
            currency: "TRY",
            unit: "LTR",
            alias: "etiket",
            explanation: "Tam Yağlı",
            kdvPurchaseExemption: "301",
            kdvSellExemption: "",
            gtip: "123456789102"
        });
        return data;
    }

    async exportStockToExcelCurreny() {
        let data = [];
        data.push({
            currency: "PARA BİRİMLERİ",
            currencyCode: "PARA BİRİM KODU"
        });
        let params = {
            url: "/stock/getCurrencyCodes",
            method: "get"
        };
        await request(params)
            .then(function (response) {
                let currencyCodes = response.data;
                for (let i = 0; i < currencyCodes.length; i++) {
                    let longCode = currencyCodes[i].longCode;
                    let shortCode = currencyCodes[i].shortCode;
                    data.push({
                        currency: longCode,
                        currencyCode: shortCode
                    });
                }
            }).catch(function (error) {
                showAxiosError(error);
            });

        return data;
    }

    async exportStockToExcelUnits() {
        let data = [];
        data.push({
            unit: "STOK BİRİMLERİ",
            unitCode: "STOK BİRİM KODU"
        });
        let params = {
            url: "/stock/getUnitCodes",
            method: "get"
        };
        await request(params)
            .then(function (response) {
                let unitCodes = response.data;
                for (let i = 0; i < unitCodes.length; i++) {
                    let longCode = unitCodes[i].longCode;
                    let shortCode = unitCodes[i].shortCode;
                    data.push({
                        unit: longCode,
                        unitCode: shortCode
                    });
                }
            }).catch(function (error) {
                showAxiosError(error);
            });

        return data;
    }

    getExemptions(){
        let self=this;
        let data = [];
        let params = {
            url: "/stock/getExemptionCodes",
            method: "get"
        };
        request(params)
            .then(function (response) {
                let exemptionCodes = response.data;
                self.setState({exemptions:exemptionCodes});
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    async exportExemptionsToExcel() {
        let data = [];
        let self=this;
        data.push({
            exemption: "KDV İSTİSNA SEBEPLERİ",
            exemptionCode: "İSTİSNA KODU",
            invoiceType : "FATURA_TİPİ"
        });
        let params = {
            url: "/stock/getExemptionCodes",
            method: "get"
        };

        let exemptionCodes = this.state.exemptions;
        for (let i = 0; i < exemptionCodes.length; i++) {
            let longCode = exemptionCodes[i].longCode;
            let numberCode = exemptionCodes[i].numberCode;
            let invoiceType = exemptionCodes[i].invoiceType;
            data.push({
                exemption: longCode,
                exemptionCode: numberCode,
                invoiceType :invoiceType,
            });
        }
        return data;
    }



    async exportStockToExcelStoppageTypes() {
        let data = [];
        data.push({
            stoppageCode: "GV STOPAJI KODU",
            stoppageName: "GV STOPAJI ADI",
            stoppagePercent: "ORAN",
        });
        let params = {
            url: "/common/allStoppageTypes",
            method: "get"
        };
        await request(params)
            .then(function (response) {
                let stoppageTypes = response.data;
                for (let i = 0; i < stoppageTypes.length; i++) {
                    data.push({
                        stoppageCode: stoppageTypes[i].code,
                        stoppageName: stoppageTypes[i].longName,
                        stoppagePercent:stoppageTypes[i].percentage,
                    });
                }
            }).catch(function (error) {
                showAxiosError(error);
            });

        return data;
    }

    async getStoppageTypes(){
        let stoppageTypes=[];
        let params = {
            url: "/common/allStoppageTypes",
            method: "get"
        };
        await request(params)
            .then(function (response) {
                stoppageTypes = response.data;
            }).catch(function (error) {
                showAxiosError(error);
            });

        return stoppageTypes;
    }
    async exportWithholdingTypes() {
        let withholdingTypes=[];
        let params = {
            url: "/common/allWithholdingTypes",
            method: "get"
        };
        await request(params)
            .then(function (response) {
                withholdingTypes = response.data;
            }).catch(function (error) {
                showAxiosError(error);
            });

        return withholdingTypes;
    }

    async exportWithholdingTypesToExcel() {
        let withholdingTypes = [];
        withholdingTypes.push({
            withholdingCode: "KDV TEVKIFATI KODU",
            withholdingName: "KDV TEVKIFATI ADI",
            withholdingPercent: "ORAN",
        });
        let params = {
            url: "/common/allWithholdingTypes",
            method: "get"
        };
        await request(params)
            .then(function (response) {
                let withholdingType = response.data;
                for (let i = 0; i < withholdingType.length; i++) {
                    withholdingTypes.push({
                        withholdingCode: withholdingType[i].code,
                        withholdingName: withholdingType[i].longName,
                        withholdingPercent:withholdingType[i].percentage,
                    });
                }
            }).catch(function (error) {
                showAxiosError(error);
            });
        return withholdingTypes;
    }



    exportInvoiceToExcel() {
        let data = [];
        data.push({
            documentNo: "FATURA_NO",
            profileId: "SENARYO_TURU",
            invoiceTypeCode: "FATURA_TIPI",
            issueDate: "FATURA_TARIHI",
            issueTime: "FATURA_SAATI",
            destinationUrn: "ALICI_POSTA_KUTUSU_ETIKETI",
            sourceUrn: "GONDERICI_BIRIM_ETIKETI",
            email: "ALICI_EPOSTA",
            documentCurrencyCode: "PARA_BIRIMI",
            paymentExchangeRate: "KUR_DEGERI",
            vknTckn: "ALICI_VKN_TCKN",
            formattedName: "ALICI_UNVAN",
            givenName: "ALICI_ADI",
            familyName: "ALICI_SOYADI",
            citySubdivisionName: "ILCE",
            cityName: "IL",
            countryName: "ULKE",
            streetName: "ADRES",
            taxOffice: "VERGI_DAIRESI",
            invoiceNumber: "IADE_FATURA_NUMARASI",
            iadeIssueDate: "IADE_FATURA_TARIHI",
            iadeIssueTime: "IADE_FATURA_SAATI",
            itemName: "URUN_ADI",
            quantity: "MIKTAR",
            unitPrice: "BIRIM_FIYAT",
            unit: "BIRIM",
            iskontoPercentage: "ISKONTO(%)",
            kdvPercentage: "KDV(%)",
            exemptionCode: "İSTİSNA KODU",
            note: "FATURA AÇIKLAMASI",
            referenceId:"İRSALİYE NO",
            referenceIssueDate: "İRSALİYE TARİHİ",
            gtip: "GTİP NUMARASI",
            tevkifatAmount: "KDV_TEVKIFATI",
            internetSaleArea: "BUNDAN SONRAKI ALANLAR INTERNET UZERINDEN SATIS ICINDIR!",
            webSite:"WEB_SITESI",
            paymentMethod:"ODEME_SEKLI",
            paymentDetails:"ODEME_DETAYI",
            paymentDate:"ODEME_TARIHI",
            carrierFirstName:"TASIYICI_ADI",
            carrierFamilyName:"TASIYICI_SOYADI",
            carrierTitle:"TASIYICI_UNVAN",
            carrierVknTckn:"TASIYICI_VKN_TCKN",
            deliveryDate:"GONDERIM_TARIHI",
            telephone:"ALICI_TELEFON_NO"
        });

        data.push({
            documentNo: "FATURA_1",
            profileId: (this.props.profileId === "EARSIVFATURA" ? "EARSIVFATURA" : "TEMELFATURA"),
            invoiceTypeCode: "SATIS",
            issueDate: "12/10/2018",
            issueTime: "11:53:39",
            destinationUrn: (this.props.profileId === "EARSIVFATURA" ? "" : "urn:mail:defaultpk@ornek1.com.tr"),
            sourceUrn: (this.props.profileId === "EARSIVFATURA" ? "" : "urn:mail:defaultgb@ornek.com.tr"),
            email: "testt@testt.com",
            documentCurrencyCode: "TRY",
            paymentExchangeRate: undefined,
            vknTckn: (this.props.profileId === "EARSIVFATURA" ? "11111111111" : "1582327065"),
            formattedName: "Kolaysoft Test",
            givenName: (this.props.profileId === "EARSIVFATURA" ? "Arşiv Fatura" :""),
            familyName: (this.props.profileId === "EARSIVFATURA" ? "Soyad" :""),
            citySubdivisionName: "Çankaya",
            cityName: "Ankara",
            countryName: "Türkiye",
            streetName: "HÜSAMETTİN ÇELEBİ MAHALLESİ GÜZELDERE CADDESİ SERKENT SİTESİ 23/9",
            taxOffice: "",
            invoiceNumber: "ABC2025000000105",
            iadeIssueDate: "12/10/2018",
            iadeIssueTime: "11:53:39",
            itemName: "Kişiye Özel Resim Öğretmeni Kalpli Kupa Bardak - Kırmızı 11131",
            quantity: 1.00,
            unitPrice: 46.99,
            unit: "ADET",
            iskontoPercentage: 0.00,
            kdvPercentage: 20.00,
            exemptionCode: "",
            note:  "AÇIKLAMA 1",
            referenceId:"1234567890",
            referenceIssueDate: "01-01-2020",
            gtip: "",
            tevkifatAmount: "",
            internetSaleArea:"DOLDURMAYINIZ",
            webSite:"www.ornek.com",
            paymentMethod:"",
            paymentDetails:"ODEME_DETAYI",
            paymentDate:"01/01/2000",
            carrierFirstName:"TASIYICI ADI",
            carrierFamilyName:"TASIYICI SOYADI",
            carrierTitle:"",
            carrierVknTckn:"11111111111",
            deliveryDate:"01/01/2000",
            telephone:"905555555555"
        });

        data.push({
            documentNo: "FATURA_1",
            profileId: (this.props.profileId === "EARSIVFATURA" ? "EARSIVFATURA" : "TEMELFATURA"),
            invoiceTypeCode: "SATIS",
            issueDate: "12/10/2018",
            issueTime: "11:53:39",
            destinationUrn: (this.props.profileId === "EARSIVFATURA" ? "" : "urn:mail:defaultpk@ornek1.com.tr"),
            sourceUrn: (this.props.profileId === "EARSIVFATURA" ? "" : "urn:mail:defaultgb@ornek.com.tr"),
            email: "deneme@deneme.com.tr",
            documentCurrencyCode: "TRY",
            paymentExchangeRate: undefined,
            vknTckn: (this.props.profileId === "EARSIVFATURA" ? "11111111111" : "1582327065"),
            formattedName: "Kolaysoft Test",
            givenName: (this.props.profileId === "EARSIVFATURA" ? "Arşiv Fatura" :""),
            familyName: (this.props.profileId === "EARSIVFATURA" ? "Soyad" :""),
            citySubdivisionName: "Çankaya",
            cityName: "Ankara",
            countryName: "Türkiye",
            streetName: "HÜSAMETTİN ÇELEBİ MAHALLESİ GÜZELDERE CADDESİ SERKENT SİTESİ 23/9",
            taxOffice: "",
            invoiceNumber: "ABC2025000000105",
            iadeIssueDate: "12/10/2018",
            iadeIssueTime: "11:53:39",
            itemName: "Kişiye Özel Resim Öğretmeni Kalpli Kupa Bardak - Kırmızı 11131",
            quantity: 3.00,
            unitPrice: 56.99,
            unit: "ADET",
            iskontoPercentage: 0.00,
            kdvPercentage: 20.00,
            exemptionCode: "",
            note: "AÇIKLAMA 1",
            referenceId:"1234567890",
            referenceIssueDate: "01-01-2020",
            gtip: "",
            tevkifatAmount: "",
            internetSaleArea:"DOLDURMAYINIZ",
            webSite:"www.ornek.com",
            paymentMethod:"",
            paymentDetails:"ODEME_DETAYI",
            paymentDate:"01/01/2000",
            carrierFirstName:"TASIYICI ADI",
            carrierFamilyName:"TASIYICI SOYADI",
            carrierTitle:"",
            carrierVknTckn:"11111111111",
            deliveryDate:"01/01/2000",
            telephone:"905555555555"
        });

        data.push({
            documentNo: "FATURA_2",
            profileId: (this.props.profileId === "EARSIVFATURA" ? "EARSIVFATURA" : "TICARIFATURA"),
            invoiceTypeCode: "SATIS",
            issueDate: "12/10/2018",
            issueTime: "11:54:51",
            destinationUrn: (this.props.profileId === "EARSIVFATURA" ? "" : "urn:mail:defaultpk@abb.com.tr"),
            sourceUrn: (this.props.profileId === "EARSIVFATURA" ? "" : "urn:mail:defaultgb@ornek.com.tr"),
            email: "deneme@deneme.com.tr",
            documentCurrencyCode: "TRY",
            paymentExchangeRate: undefined,
            vknTckn: (this.props.profileId === "EARSIVFATURA" ? "2222222222" : "3433768056"),
            formattedName: (this.props.profileId === "EARSIVFATURA" ? "Test A.Ş." : "batanik batanik batanik1"),
            givenName: "",
            familyName: "",
            citySubdivisionName: "SELÇUKLU",
            cityName: "KONYA",
            countryName: "Türkiye",
            streetName: "VAKIF BİNASI 30/9",
            taxOffice: "",
            invoiceNumber: "ABC2025000000105",
            iadeIssueDate: "12/10/2018",
            iadeIssueTime: "11:53:39",
            itemName: "Kuruma Özel Resim Öğretmeni Kalpli Kupa Bardak - Kırmızı 11131",
            quantity: 1.00,
            unitPrice: 46.99,
            unit: "ADET",
            iskontoPercentage: 0.00,
            kdvPercentage: 20.00,
            exemptionCode: "",
            note: "",
            referenceId:"",
            referenceIssueDate: "",
            gtip: "",
            tevkifatAmount: "",
            internetSaleArea:"DOLDURMAYINIZ",
            webSite:"www.ornek.com",
            paymentMethod:"",
            paymentDetails:"ODEME_DETAYI",
            paymentDate:"01/01/2000",
            carrierFirstName:"TASIYICI ADI",
            carrierFamilyName:"TASIYICI SOYADI",
            carrierTitle:"",
            carrierVknTckn:"11111111111",
            deliveryDate:"01/01/2000",
            telephone:""
        });

        data.push({
            documentNo: "FATURA_2",
            profileId: (this.props.profileId === "EARSIVFATURA" ? "EARSIVFATURA" : "TICARIFATURA"),
            invoiceTypeCode: "SATIS",
            issueDate: "12/10/2018",
            issueTime: "11:54:51",
            destinationUrn: (this.props.profileId === "EARSIVFATURA" ? "" : "urn:mail:defaultpk@abb.com.tr"),
            sourceUrn: (this.props.profileId === "EARSIVFATURA" ? "" : "urn:mail:defaultgb@ornek.com.tr"),
            email: "deneme@deneme.com.tr",
            documentCurrencyCode: "TRY",
            paymentExchangeRate: undefined,
            vknTckn: (this.props.profileId === "EARSIVFATURA" ? "2222222222" : "3433768056"),
            formattedName: (this.props.profileId === "EARSIVFATURA" ? "Test A.Ş." : "batanik batanik batanik1"),
            givenName: "",
            familyName: "",
            citySubdivisionName: "SELÇUKLU",
            cityName: "KONYA",
            countryName: "Türkiye",
            streetName: "VAKIF BİNASI 30/9",
            taxOffice: "",
            invoiceNumber: "ABC2025000000105",
            iadeIssueDate: "12/10/2018",
            iadeIssueTime: "11:53:39",
            itemName: "Ürün-2 - Beyaz 11131",
            quantity: 2.00,
            unitPrice: 46.99,
            unit: "ADET",
            iskontoPercentage: 0.00,
            kdvPercentage: 0.00,
            exemptionCode: "351",
            note:"",
            referenceId:"",
            referenceIssueDate: "",
            gtip: "",
            tevkifatAmount: "",
            internetSaleArea:"DOLDURMAYINIZ",
            webSite:"www.ornek.com",
            paymentMethod:"",
            paymentDetails:"ODEME_DETAYI",
            paymentDate:"01/01/2000",
            carrierFirstName:"TASIYICI ADI",
            carrierFamilyName:"TASIYICI SOYADI",
            carrierTitle:"",
            carrierVknTckn:"11111111111<",
            deliveryDate:"01/01/2000",
            telephone:"",
        });
        return data;
    }

    exportBelgeToExcel() {
        let data = [];
        data.push({
            documentNo: "BELGE_NO",
            documentTypeCode: "FATURA_TIPI",
            issueDate: "FATURA_TARIHI",
            issueTime: "FATURA_SAATI",
            email: "ALICI_EPOSTA",
            documentCurrencyCode: "PARA_BIRIMI",
            paymentExchangeRate: "KUR_DEGERI",
            vknTckn: "ALICI_VKN_TCKN",
            formattedName: "ALICI_UNVAN",
            givenName: "ALICI_ADI",
            familyName: "ALICI_SOYADI",
            citySubdivisionName: "ILCE",
            cityName: "IL",
            countryName: "ULKE",
            streetName: "ADRES",
            taxOffice: "VERGI_DAIRESI",
            itemName: "URUN_ADI",
            quantity: "MIKTAR",
            unitPrice: "BIRIM_FIYAT",
            unit: "BIRIM",
            iskontoPercentage: "ISKONTO(%)",
            kdvPercentage: "KDV(%)",
            exemptionCode: "İSTİSNA KODU",
            note: "FATURA AÇIKLAMASI",
            referenceId:"İRSALİYE NO",
            referenceIssueDate: "İRSALİYE TARİHİ",
            tevkifatAmount: "KDV_TEVKIFATI",
        });

        data.push({
            documentNo: "FATURA_1",
            documentTypeCode: "SATIS",
            issueDate: "12/10/2018",
            issueTime: "11:53:39",
            email: "testt@testt.com",
            documentCurrencyCode: "TRY",
            paymentExchangeRate: undefined,
            vknTckn: "11111111111",
            formattedName: "Kolaysoft Test",
            givenName: "Arşiv Fatura",
            familyName: "Soyad",
            citySubdivisionName: "Çankaya",
            cityName: "Ankara",
            countryName: "Türkiye",
            streetName: "HÜSAMETTİN ÇELEBİ MAHALLESİ GÜZELDERE CADDESİ SERKENT SİTESİ 23/9",
            taxOffice: "",
            itemName: "Kişiye Özel Resim Öğretmeni Kalpli Kupa Bardak - Kırmızı 11131",
            quantity: 1.00,
            unitPrice: 46.99,
            unit: "ADET",
            iskontoPercentage: 0.00,
            kdvPercentage: 20.00,
            exemptionCode: "",
            note:  "AÇIKLAMA 1",
            referenceId:"1234567890",
            referenceIssueDate: "01-01-2020",
            tevkifatAmount: "",
        });

        data.push({
            documentNo: "FATURA_1",
            documentTypeCode: "SATIS",
            issueDate: "12/10/2018",
            issueTime: "11:53:39",
            email: "deneme@deneme.com.tr",
            documentCurrencyCode: "TRY",
            paymentExchangeRate: undefined,
            vknTckn: "11111111111",
            formattedName: "Kolaysoft Test",
            givenName: "Arşiv Fatura",
            familyName: "Soyad",
            citySubdivisionName: "Çankaya",
            cityName: "Ankara",
            countryName: "Türkiye",
            streetName: "HÜSAMETTİN ÇELEBİ MAHALLESİ GÜZELDERE CADDESİ SERKENT SİTESİ 23/9",
            taxOffice: "",
            itemName: "Kişiye Özel Resim Öğretmeni Kalpli Kupa Bardak - Kırmızı 11131",
            quantity: 3.00,
            unitPrice: 56.99,
            unit: "ADET",
            iskontoPercentage: 0.00,
            kdvPercentage: 20.00,
            exemptionCode: "",
            note: "AÇIKLAMA 1",
            referenceId:"1234567890",
            referenceIssueDate: "01-01-2020",
            tevkifatAmount: "",
        });

        data.push({
            documentNo: "FATURA_2",
            documentTypeCode: "SATIS",
            issueDate: "12/10/2018",
            issueTime: "11:54:51",
            email: "deneme@deneme.com.tr",
            documentCurrencyCode: "TRY",
            paymentExchangeRate: undefined,
            vknTckn:  "2222222222",
            formattedName: "Test A.Ş.",
            givenName: "",
            familyName: "",
            citySubdivisionName: "SELÇUKLU",
            cityName: "KONYA",
            countryName: "Türkiye",
            streetName: "VAKIF BİNASI 30/9",
            taxOffice: "",
            itemName: "Kuruma Özel Resim Öğretmeni Kalpli Kupa Bardak - Kırmızı 11131",
            quantity: 1.00,
            unitPrice: 46.99,
            unit: "ADET",
            iskontoPercentage: 0.00,
            kdvPercentage: 20.00,
            exemptionCode: "",
            note: "",
            referenceId:"",
            referenceIssueDate: "",
            tevkifatAmount: "",
        });

        data.push({
            documentNo: "FATURA_2",
            documentTypeCode: "SATIS",
            issueDate: "12/10/2018",
            issueTime: "11:54:51",
            email: "deneme@deneme.com.tr",
            documentCurrencyCode: "TRY",
            paymentExchangeRate: undefined,
            vknTckn: "2222222222",
            formattedName: "Test A.Ş.",
            givenName: "",
            familyName: "",
            citySubdivisionName: "SELÇUKLU",
            cityName: "KONYA",
            countryName: "Türkiye",
            streetName: "VAKIF BİNASI 30/9",
            taxOffice: "",
            itemName: "Ürün-2 - Beyaz 11131",
            quantity: 2.00,
            unitPrice: 46.99,
            unit: "ADET",
            iskontoPercentage: 0.00,
            kdvPercentage: 0.00,
            exemptionCode: "351",
            note:"",
            referenceId:"",
            referenceIssueDate: "",
            tevkifatAmount: "",
        });
        return data;
    }

    exportSigortaToExcel(){
        let data = [];
        data.push({
            documentNo: "SIGORTA_NO",
            issueDate: "SIGORTA_TARIHI",
            issueTime: "SIGORTA_SAATI",
            documentCurrencyCode: "PARA_BIRIMI",
            paymentExchangeRate: "KUR_DEGERI",
            vknTckn: "ALICI_VKN_TCKN",
            formattedName: "ALICI_UNVAN",
            givenName: "ALICI_ADI",
            familyName: "ALICI_SOYADI",
            postboxAlias: "ALICI_ETIKETI",
            citySubdivisionName: "ILCE",
            cityName: "IL",
            countryName: "ULKE",
            streetName: "ADRES",
            taxOffice: "VERGI_DAIRESI",
            itemName: "AÇIKLAMA",
            productCommissionPrice: "ISTIHSAL_KOMISYONU",
            cancelCommissionPrice: "IPTAL_KOMISYONU",
            periodStartDateTime: "DÖNEM_BAŞLANGIÇ_TARIHI",
            periodEndDateTime: "DÖNEM_BITIŞ_TARIHI",
            note: "SIGORTA_AÇIKLAMASI"
        });

        data.push({
            documentNo: "SIGORTA 1",
            issueDate: "02/10/2025",
            issueTime: "11:53:39",
            documentCurrencyCode: "TRY",
            paymentExchangeRate: undefined,
            vknTckn: "11111111111",
            formattedName: "Kolaysoft Test",
            givenName: "Ali",
            familyName: "Soyad",
            postboxAlias: "urn:mail:defaultpk@ornek1.com.tr",
            citySubdivisionName: "Çankaya",
            cityName: "Ankara",
            countryName: "Türkiye",
            streetName: "HÜSAMETTİN ÇELEBİ MAHALLESİ GÜZELDERE CADDESİ SERKENT SİTESİ 23/9",
            taxOffice: "",
            itemName: "Mühendislik",
            productCommissionPrice: 12.00,
            cancelCommissionPrice: 10.99,
            periodStartDateTime: "01-09-2025 00:00:00",
            periodEndDateTime: "15-09-2025 23:59:59",
            note:  "AÇIKLAMA 1",
        });

        data.push({
            documentNo: "SIGORTA 2",
            issueDate: "13/02/2025",
            issueTime: "11:54:51",
            documentCurrencyCode: "TRY",
            paymentExchangeRate: undefined,
            vknTckn: "2222222222",
            formattedName: "Test A.Ş.",
            givenName: "Ad",
            familyName: "Soyad",
            postboxAlias: "urn:mail:defaultpk@ornek1.com.tr",
            citySubdivisionName: "SELÇUKLU",
            cityName: "KONYA",
            countryName: "Türkiye",
            streetName: "VAKIF BİNASI 30/9",
            taxOffice: "",
            itemName: "Sağlık",
            productCommissionPrice: 2.00,
            cancelCommissionPrice: 0.00,
            periodStartDateTime: "16-01-2025 00:00:00",
            periodEndDateTime: "31-01-2025 23:59:59",
            note:"AÇIKLAMA",
        });
        return data;
    }

    exportVoucherToExcel() {
        let data = [];
        data.push({
            documentNo: "Makbuz_No",
            issueDate: "TARIH(GÜN/AY/YIL Saat:Dakika:saniye formatında okunur.)",
            fullName: "ADI SOYADI",
            vknTckn: "T.C. NO",
            fullAddress: "ADRES(EK BİLGİ /İLÇE / İL)",
            itemName: "ÜRÜN",
            quantity: "MİKTAR",
            unit: "BIRIM",
            unitPrice: "B.FİYAT",
            gvStoppageCode: "GV_STOPAJI_KODU",
            borsaAmount: "BORSA_TES_UC_TUTARI",
            meraAmount: "MERA_FONU_TUTARI",
            sgkAmount: "SGK_PRIM_KESİNTİ_TUTARI",
            lineExtensionAmount: "TUTAR",
            stockCode: "SATICI_MAL_KODU"
        });

        data.push({
            documentNo: "Makbuz_1",
            issueDate: "25/07/2018 00:09:00",
            fullName: "Ali Baba",
            vknTckn: "24404018742",
            fullAddress: "Ağılköy / Eğirdir / Isparta",
            itemName: "ELMA",
            quantity: 9998,
            unit: "ADET",
            unitPrice: 0.5,
            gvStoppageCode: "091",
            borsaAmount: "",
            meraAmount: "",
            sgkAmount: "",
            lineExtensionAmount: 4999.00,
            stockCode: "EL001-KRM"
        });
        data.push({
            documentNo: "Makbuz_1",
            issueDate: "25/07/2018 00:09:001",
            fullName: "Ali Baba",
            vknTckn: "24404018742",
            fullAddress: "Ağılköy / Eğirdir / Isparta",
            itemName: "ARMUT",
            quantity: 1256.15,
            unit: "ADET",
            unitPrice: 0.5,
            gvStoppageCode: "091",
            borsaAmount: "",
            meraAmount: "",
            sgkAmount: "",
            lineExtensionAmount: 627975.02,
            stockCode: "AR001-YSL"
        });
        data.push({
            documentNo: "Makbuz_2",
            issueDate: "25/07/2018 00:09:00",
            fullName: "Veli DEDE",
            vknTckn: "24404018758",
            fullAddress: "Ağılköy / Eğirdir / Isparta",
            itemName: "ARMUT",
            quantity: 1256.15,
            unit: "ADET",
            unitPrice: 0.5,
            gvStoppageCode: "091",
            borsaAmount: "",
            meraAmount: "",
            sgkAmount: "",
            lineExtensionAmount: 627975.02,
            stockCode: "AR002-YSL"
        });
        return data;
    }

    exportSVoucherToExcel() {
        let data = [];
        data.push({
            documentNo: "Makbuz_No",
            issueDate: "TARIH(GÜN/AY/YIL Saat:Dakika:saniye formatında okunur.)",
            vknTckn: "ALICI_VKN_TCKN",
            formattedName: "ALICI_UNVAN",
            givenName: "ALICI_ADI",
            familyName: "ALICI_SOYADI",
            itemName: "URUN",
            citySubdivisionName: "ILCE",
            cityName: "IL",
            tevkifatAmount: "KDV_TEVKIFATI(₺)",
            gercekAmount: "KDV_GERCEK(₺)",
            gvStoppageCode: "GV_STOPAJI_KODU",
            percentage: "GV_STOPAJI_ORANI",
            lineExtensionAmount: "BRUT_UCRET(₺)",
            note: "ACIKLAMA"
        });

        data.push({
            documentNo: "Makbuz_1",
            issueDate: "25/07/2018 00:09:00",
            vknTckn: "24404018742",
            formattedName: "Ali Baba",
            givenName: "Ali",
            familyName: "Baba",
            itemName: "Avukatlık Hizmeti",
            citySubdivisionName: "Eğirdir",
            cityName: "Isparta",
            tevkifatAmount: "8",
            gercekAmount: "80",
            gvStoppageCode:"021",
            percentage: null,
            lineExtensionAmount: "100",
            note: "Temmuz ayı ödeme"
        });

        data.push({
            documentNo: "Makbuz_1",
            issueDate: "25/07/2018 00:09:00",
            vknTckn: "24404018742",
            formattedName: "Ali Baba",
            givenName: "Ali",
            familyName: "Baba",
            itemName: "Avukatlık Hizmeti",
            citySubdivisionName: "Eğirdir",
            cityName: "Isparta",
            tevkifatAmount: "8",
            gercekAmount: "80",
            gvStoppageCode:"021",
            percentage: null,
            lineExtensionAmount: "150",
            note: "Temmuz ayı ödeme"
        });
        data.push({
            documentNo: "Makbuz_2",
            issueDate: "25/07/2018 00:09:00",
            vknTckn: "24404018986",
            formattedName: "Veli Dede",
            givenName: "Veli",
            familyName: "DEDE",
            itemName: "Danışmanlık Hizmeti",
            citySubdivisionName: "Atabey",
            cityName: "Isparta",
            tevkifatAmount: "8",
            gercekAmount: "18.5",
            gvStoppageCode:"023",
            percentage: "12",
            lineExtensionAmount: "50",
            note: "Temmuz ayı ödeme"
        });
        return data;
    }

    exportDespatchToExcel() {
        let data = [];
        data.push({
            documentNo: "Irsaliye_No",
            givenName: "ALICI_ADI",
            familyName: "ALICI_SOYADI",
            vknTckn: "ALICI_VKN_TCKN",
            cityName: "IL",
            citySubdivisionName: "ILCE",
            streetName: "ADRES",
            postboxAlias: "ALICI_ETIKETI",
            sourceUrn: "GONDERICI_BIRIM_ETIKETI",
            issueDate: "IRSALIYE_TARIHI",
            issueTime: "IRSALIYE_SAATI",
            formattedName: "ALICI_UNVAN",
            deliveryStreetName: "TESLIMAT_EDİLECEK_ADRES",
            deliveryPostalZone: "TESLIMAT_EDİLECEK_POSTA_KODU",
            deliveryCitySubdivision: "TESLIMAT_EDİLECEK_ILCE",
            deliveryCity: "TESLIMAT_EDİLECEK_IL",
            deliveryType: "TAŞIYICI_TÜRÜ",
            carrierId: "TASIYICI_VKN/TCKN(ŞAHIS VE FİRMA İÇİN ZORUNLU)",
            carrierTitle: "TASIYICI_UNVAN(FİRMA İÇİN ZORUNLU)",
            driverFirstName: "ŞOFÖR_ADI(ŞAHIS İÇİN ZORUNLU)",
            driverFamilyName: "ŞOFÖR_SOYADI(ŞAHIS İÇİN ZORUNLU)",
            licensePlateID: "PLAKA",
            actualDespatchDatetime: "SEVK_TARIHI",
            actualDespatchDatehour: "SEVK_SAATİ",
            orderReferenceNumber: "SIPARIS_NO",
            orderReferenceDate: "SIPARIS_TARIHI",
            itemName: "URUN",
            quantity: "MIKTAR",
            unit: "BIRIM",
            unitPrice: "BIRIM_FIYAT",
            note: "FATURA AÇIKLAMASI",


        });
        data.push({
            documentNo: "Irsaliye_1",
            givenName: "Ali",
            familyName: "Baba",
            vknTckn: "24404018742",
            cityName: "Isparta",
            citySubdivisionName: "Eğirdir",
            streetName: "Mustafalı Caddesi No:30",
            postboxAlias: "urn:mail:defaultpk@ornek1.com.tr",
            sourceUrn: "urn:mail:defaultgb@ornek.com.tr",
            issueDate: "01/07/2018",
            issueTime: "00:09:00",
            formattedName: "Ali Baba",
            deliveryStreetName: "TESLIM EDİLECEK ADRES",
            deliveryPostalZone: "06340",
            deliveryCitySubdivision: "Seyhan",
            deliveryCity: "Adana",
            deliveryType: "Firma",
            carrierId: "1212121212",
            carrierTitle: "Taşıyıcı Unvan",
            driverFirstName: "",
            driverFamilyName: "",
            licensePlateID: "PLAKA",
            actualDespatchDatetime: "01/07/2018",
            actualDespatchDatehour: " 00:09:00",
            orderReferenceNumber: "AB123456",
            orderReferenceDate: "01/07/2018",
            itemName: "Elma",
            quantity: "1",
            unit: "C62",
            unitPrice: "50.75",
            note: "FATURA AÇIKLAMASI",
        });
        data.push({
            documentNo: "Irsaliye_1",
            givenName: "Ali",
            familyName: "Baba",
            vknTckn: "24404018742",
            cityName: "Isparta",
            citySubdivisionName: "Eğirdir",
            streetName: "Mustafalı Caddesi No:30",
            postboxAlias: "urn:mail:defaultpk@ornek1.com.tr",
            sourceUrn: "urn:mail:defaultgb@ornek.com.tr",
            issueDate: "01/07/2018",
            issueTime: "00:09:00",
            formattedName: "Ali Baba",
            deliveryStreetName: "TESLIM EDİLECEK ADRES",
            deliveryPostalZone: "06340",
            deliveryCitySubdivision: "Seyhan",
            deliveryCity: "Adana",
            deliveryType: "Firma",
            carrierId: "1212121212",
            carrierTitle: "Taşıyıcı Unvan",
            driverFirstName: "",
            driverFamilyName: "",
            licensePlateID: "PLAKA",
            actualDespatchDatetime: "03/07/2018",
            actualDespatchDatehour: " 00:09:00",
            orderReferenceNumber: "AB123456",
            orderReferenceDate: "01/07/2018",
            itemName: "Armut",
            quantity: "2",
            unit: "C62",
            unitPrice: "25.25",
            note: "FATURA AÇIKLAMASI",
        });
        data.push({
            documentNo: "Irsaliye_2",
            givenName: "Veli",
            familyName: "DEDE",
            vknTckn: "24404018893",
            cityName: "Isparta",
            postboxAlias: "urn:mail:defaultpk@ornek1.com.tr",
            citySubdivisionName: "Eğirdir",
            streetName: "Mustafalı Caddesi No:30",
            sourceUrn: "urn:mail:defaultgb@ornek.com.tr",
            issueDate: "01/08/2018",
            issueTime: "00:09:00",
            formattedName: "Veli",
            deliveryStreetName: "TESLIM EDİLECEK ADRES",
            deliveryPostalZone: "06340",
            deliveryCitySubdivision: "Alanya",
            deliveryCity: "Antalya",
            deliveryType: "Şahıs",
            carrierId: "1212121212",
            carrierTitle: "",
            driverFirstName: "Ahmet",
            driverFamilyName: "Şen",
            licensePlateID: "PLAKA",
            actualDespatchDatetime: "01/07/2018",
            actualDespatchDatehour: " 00:09:00",
            orderReferenceNumber: "AB123456",
            orderReferenceDate: "01/07/2018",
            itemName: "Kayısı",
            quantity: "22",
            unit: "C62",
            unitPrice: "85.15",
            note: "FATURA AÇIKLAMASI",
        });
        return data;
    }

    onCancel() {
        if (this._source)
            this._source.cancel();

        if (this.state.index > 0) {
            this.props.toggleModal(false, true);
        } else {
            this.props.toggleModal(false, false);
        }
    }

    getStatusRender(status) {
        let className = (status === "processing" ? "spinner fa-spin" : (status === "success" ? "check" : (status === "error" ? "close" : "pause")));
        let color = (status === "processing" ? "dark" : (status === "success" ? "green" : (status === "error" ? "red" : "dark")));
        return (<i className={"fas fa-" + className} style={{color: color, paddingRight: "4px"}}></i>);
    }

    orientation(e) {
        if (this.props.type === "invoice") {
            this.saveNextDocument(this.state.index);
        } else if (this.props.type === "sVoucher" || this.props.type === "voucher") {
            this.sendDocument(e);
        } else if (this.props.type === "belge") {
            this.sendBelge(this.state.index);
        } else if (this.props.type === "despatch") {
            this.sendDespatch(e);
        } else if (this.props.type === "stockList") {
            this.saveStockList(e);
        }  else if (this.props.type === "sigorta") {
            this.saveSigorta(e);
        } else if (this.props.type === "externalCustomerList") {
            this.saveExternalCustomerList(e);
        }
    }


    render() {
        const {isMobile} = this.state;
        return (
            <DefaultModal
                isOpen={this.props.modal}
                disabled={this.state.btnDisabled || (this.state.documentList && this.state.documentList.length === 0) || (this.props.type === 'externalCustomerList' && (this.state.controlObjectList.length>0 && this.state.controlObjectList.includes(0)))}
                title={(["stockList","externalCustomerList"].includes(this.props.type)) ? "Excel'den Kaydet" : "Excel'den Taslağa Kaydet"}
                size="lg"
                modalBodyStyle={{padding: "0", minHeight: "500px"}}
                confirmBtnText={(["stockList","externalCustomerList"].includes(this.props.type)) ? "Kaydet" : "Taslağa Kaydet"}
                cancelBtnText="İptal"
                onConfirm={(e) => this.orientation(e)}
                onCancel={this.onCancel}>
                <div className={isMobile ? "col p-0" : "row"} style={isMobile ? {justifyContent:'center'} : {}}>
                    <Col sm="2">
                        <input ref={this.inputFile}
                               type="file" accept=".xlsx,.xls,.XLS,.XLSX" multiple={false}
                               style={{display: 'block', visibility: 'hidden', width: '0px', height: '0px'}}
                               onChange={this.fileSelected}/>
                        <button type="button"
                                disabled={(this.state.uploadBtnDisabled || this.state.btnDisabled)}
                                onClick={this.triggerFileSelect}
                                style={{background: '#87a0b1', marginBottom: '15px', marginLeft: "32px"}}
                                rel="tooltip" className="TekBtn file-alt btn-lg btn-icon">
                            Dosya Seç
                        </button>
                    </Col>
                    <Col sm="2">
                        <button type="button"
                                onClick={this.exportToExcel}
                                style={{background: '#19cf88', marginBottom: '15px', marginLeft: "18px"}}
                                rel="tooltip" className="TekBtn down btn-lg btn-icon">
                            Desen İndir
                        </button>
                    </Col>
                </div>
                <Col sm="12">
                    <div>
                        <div className="card-body">
                            <Row>
                                <Col sm="12" style={{paddingRight: '5px', maxHeight: '500px', overflow: "auto"}}>
                                    <table className="" style={{textAlign: 'center', paddingBottom: "5px"}}>
                                        <thead>
                                        <tr style={{backgroundColor: '#ebedf0'}}>
                                            <th>#</th>
                                            {(this.props.type === "sVoucher" || this.props.type === "voucher") &&
                                            <th>Makbuz No</th>
                                            }
                                            {this.props.type === "externalCustomerList" &&
                                            <th>VKN/TCKN</th>
                                            }
                                            {this.props.type === "externalCustomerList" &&
                                            <th>Unvan</th>
                                            }
                                            {this.props.type === "externalCustomerList" &&
                                            <th>Adı</th>
                                            }
                                            {this.props.type === "externalCustomerList" &&
                                            <th>Soyadı</th>
                                            }
                                            {this.props.type === "externalCustomerList" &&
                                            <th>Müşteri Tipi</th>
                                            }
                                            {this.props.type === "externalCustomerList" &&
                                            <th>Adres Adı</th>
                                            }
                                            {this.props.type === "externalCustomerList" &&
                                            <th>E-Fatura Alıcı Etiketi</th>
                                            }
                                            {this.props.type === "externalCustomerList" &&
                                            <th>E-İrsaliye Alıcı Etiketi</th>
                                            }
                                            {this.props.type === "externalCustomerList" &&
                                            <th>Ülke</th>
                                            }
                                            {this.props.type === "externalCustomerList" &&
                                            <th>Şehir</th>
                                            }
                                            {this.props.type === "externalCustomerList" &&
                                            <th>İlçe</th>
                                            }
                                            {this.props.type === "stockList" &&
                                            <th>Ürün/Hizmet Kodu</th>
                                            }
                                            {this.props.type === "stockList" &&
                                            <th>Ürün/Hizmet Adı</th>
                                            }
                                            {this.props.type === "stockList" &&
                                            <th>KDV Alış(%)</th>
                                            }
                                            {this.props.type === "stockList" &&
                                            <th>KDV Satış(%)</th>
                                            }
                                            {this.props.type === "stockList" &&
                                            <th>Birim Fiyat Alış</th>
                                            }
                                            {this.props.type === "stockList" &&
                                            <th>Birim Fiyat Satış</th>
                                            }
                                            {this.props.type === "stockList" &&
                                            <th>Para Birimi</th>
                                            }
                                            {this.props.type === "stockList" &&
                                            <th>Birim</th>
                                            }
                                            {this.props.type !== "stockList" && this.props.type !== "externalCustomerList" &&
                                            <th>Tarih/Saat</th>
                                            }
                                            {this.props.type !== "stockList" && this.props.type !== "externalCustomerList" &&
                                            <th>Unvan</th>
                                            }
                                            {this.props.type !== "stockList" && this.props.type !== "externalCustomerList" &&
                                            <th>TCKN</th>
                                            }
                                            {(this.props.type === "invoice" || this.props.type === "belge" || this.props.type === "sVoucher" || this.props.type === "voucher") &&
                                            <th>Ödenecek Tutar</th>
                                            }
                                            {(this.props.type === "invoice" || this.props.type === "belge") &&
                                            <th>Senaryo</th>
                                            }
                                            {(this.props.type === "invoice" || this.props.type === "belge") &&
                                            <th>Durum</th>
                                            }
                                            {this.props.type === "despatch" &&
                                            <th>Teslimat Adresi</th>
                                            }
                                            {this.props.type === "despatch" &&
                                            <th>Taşıyıcı Vkn</th>
                                            }
                                            {this.props.type === "despatch" &&
                                            <th>Taşıyıcı Ünvanı</th>
                                            }
                                            {this.props.type === "voucher" &&
                                            <th>Satıcı Mal Kodu</th>
                                            }
                                            {(this.props.type === "sVoucher" || this.props.type === "voucher") &&
                                            <th>Başarı Durumu</th>
                                            }
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.excelDatas && this.state.excelDatas.map((excelData, index) =>
                                            <tr key={index} className={ this.state.controlObjectList.length>0 && this.state.controlObjectList[index]===0 ? "red-line": ""}>
                                                <td>{index + 1}</td>
                                                {(this.props.type === "sVoucher" || this.props.type === "voucher") &&
                                                <td style={{margin: "0px"}}>{excelData.documentNo}</td>
                                                }
                                                {this.props.type === "externalCustomerList" &&
                                                <td style={{margin: "0px"}}>{excelData.vknTckn}</td>
                                                }
                                                {this.props.type === "externalCustomerList" &&
                                                <td style={{margin: "0px"}}>{excelData.formattedName}</td>
                                                }
                                                {this.props.type === "externalCustomerList" &&
                                                <td style={{margin: "0px"}}>{excelData.givenName}</td>
                                                }
                                                {this.props.type === "externalCustomerList" &&
                                                <td style={{margin: "0px"}}>{excelData.familyName}</td>
                                                }
                                                {this.props.type === "externalCustomerList" &&
                                                <td style={{margin: "0px"}}>{excelData.customerType === 1 ? "Satıcı" : excelData.customerType === 2 ? "Alıcı" : "Her İkisi"}</td>
                                                }
                                                {this.props.type === "externalCustomerList" &&
                                                <td style={{margin: "0px"}}>{excelData.externalCustomerAddressList[0].addressName}</td>
                                                }
                                                {this.props.type === "externalCustomerList" &&
                                                <td style={{margin: "0px"}}>{excelData.externalCustomerAddressList[0].postboxAlias}</td>
                                                }
                                                {this.props.type === "externalCustomerList" &&
                                                <td style={{margin: "0px"}}>{excelData.externalCustomerAddressList[0].despatchPostboxAlias}</td>
                                                }
                                                {this.props.type === "externalCustomerList" &&
                                                <td style={{margin: "0px"}}>{excelData.externalCustomerAddressList[0].countryName}</td>
                                                }
                                                {this.props.type === "externalCustomerList" &&
                                                <td style={{margin: "0px"}}>{excelData.externalCustomerAddressList[0].cityName}</td>
                                                }
                                                {this.props.type === "externalCustomerList" &&
                                                <td style={{margin: "0px"}}>{excelData.externalCustomerAddressList[0].citySubdivisionName}</td>
                                                }
                                                {this.props.type === "stockList" &&
                                                <td style={{margin: "0px"}}>{excelData.stockCode}</td>
                                                }
                                                {this.props.type === "stockList" &&
                                                <td style={{margin: "0px"}}>{excelData.stockName}</td>
                                                }
                                                {this.props.type === "stockList" &&
                                                <td style={{margin: "0px"}}>{excelData.kdvBuy}</td>
                                                }
                                                {this.props.type === "stockList" &&
                                                <td style={{margin: "0px"}}>{excelData.kdvSell}</td>
                                                }
                                                {this.props.type === "stockList" &&
                                                <td style={{margin: "0px"}}>{excelData.priceBuy}</td>
                                                }
                                                {this.props.type === "stockList" &&
                                                <td style={{margin: "0px"}}>{excelData.priceSell}</td>
                                                }
                                                {this.props.type === "stockList" &&
                                                <td style={{margin: "0px"}}>{excelData.currency}</td>
                                                }
                                                {this.props.type === "stockList" &&
                                                <td style={{margin: "0px"}}>{excelData.unit}</td>
                                                }
                                                {this.props.type !== "stockList" && this.props.type !== "externalCustomerList" && this.props.type !== "sVoucher" && this.props.type !== "voucher"&&
                                                <td>{(moment(excelData.issueDate,"DD-MM-YYYY").isValid() ? excelData.issueDate.toString() + " " +(excelData.issueTime ? excelData.issueTime : "") : excelData.issueDate +(excelData.issueTime ? excelData.issueTime : ""))}</td>
                                                }
                                                {(this.props.type === "sVoucher" || this.props.type === "voucher") &&
                                                <td>{(moment(excelData.issueDate,"DD-MM-YYYY HH:mm:ss").isValid() ? moment(excelData.issueDate).format("DD/MM/YYYY HH:mm:ss") : (excelData.issueDate.toString() === "Invalid date" ? "Hatalı Tarih" : excelData.issueDate.toString()))}</td>
                                                }
                                                {this.props.type !== "stockList" && this.props.type !== "externalCustomerList" &&
                                                <td style={{margin: "0px"}}><TextOverFlowTooltip
                                                    text={(excelData.formattedName ? excelData.formattedName : "") + " " + (excelData.fullName ? excelData.fullName : "") + " " + (excelData.givenName ? excelData.givenName : "") + " " + (excelData.familyName ? excelData.familyName : "")}
                                                    length={20}></TextOverFlowTooltip></td>
                                                }
                                                {this.props.type !== "stockList" && this.props.type !== "externalCustomerList" &&
                                                <td style={{margin: "0px"}}>{excelData.vknTckn}</td>
                                                }
                                                {(this.props.type === "invoice" || this.props.type === "belge" ||  this.props.type === "sVoucher" || this.props.type === "voucher") &&
                                                <td style={{margin: "0px"}}>{excelData.payableAmount}</td>
                                                }
                                                {(this.props.type === "invoice" || this.props.type === "belge") &&
                                                <td style={{margin: "0px"}}>{excelData.profileId}</td>
                                                }
                                                {(this.props.type === "invoice" || this.props.type === "belge") &&
                                                <td style={{margin: "0px"}}>{this.getStatusRender(excelData.status)}{(excelData.statusText || "Kayıt Bekliyor...")}</td>
                                                }

                                                {this.props.type === "despatch" &&
                                                <td style={{margin: "0px"}}>{excelData.deliveryCity + " / " + excelData.deliveryCitySubdivision}</td>
                                                }
                                                {this.props.type === "despatch" &&
                                                <td style={{margin: "0px"}}>{excelData.carrierId}</td>
                                                }
                                                {this.props.type === "despatch" &&
                                                <td style={{margin: "0px"}}>{excelData.carrierTitle}</td>
                                                }
                                                {this.props.type === "voucher" &&
                                                <td style={{margin: "0px"}}>{excelData.stockCode}</td>
                                                }
                                                {(this.props.type === "sVoucher" || this.props.type === "voucher") &&
                                                <td style={{margin: "0px"}}>{excelData.successful}</td>
                                                }
                                            </tr>
                                        )}
                                        {!this.state.processingExcel && (this.state.excelDatas && this.state.excelDatas.length === 0) &&
                                        <tr>
                                            <td colSpan="8">Kayıt bulunamadı</td>
                                        </tr>
                                        }
                                        {this.state.processingExcel &&
                                        <tr>
                                            <td colSpan="8">Doküman işleniyor...</td>
                                        </tr>
                                        }
                                        </tbody>
                                    </table>
                                </Col>
                                <Col sm="12">
                                    <p style={{float: "right"}}>Toplam
                                        Adet: {this.state.excelDatas ? this.state.excelDatas.length : 0}</p>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Col>
            </DefaultModal>
        );
    }
}

export default ReadFromExcel;

